// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hide {
    visibility: hidden !important
}

a.bottom-mrgn img {
    margin: 0 10px 0 0
}

.arr-icon-blue {
    margin-left: 5px
}

.view-for-select .form-control.custom {
    width: 72%;
    margin-left: 21px
}

@media screen and (min-width:768px) {

    div#additional_coverage .view-for-select .form-control.custom,
    div#behavioral .view-for-select .form-control.custom,
    div#dentals .view-for-select .form-control.custom,
    div#medicals .view-for-select .form-control.custom,
    div#pharmacy .view-for-select .form-control.custom,
    div#vision .view-for-select .form-control.custom {
        width: 33%
    }
}

@media screen and (max-width:767px) {

    div#additional_coverage .view-for-select .form-control.custom,
    div#behavioral .view-for-select .form-control.custom,
    div#dentals .view-for-select .form-control.custom,
    div#medicals .view-for-select .form-control.custom,
    div#pharmacy .view-for-select .form-control.custom,
    div#vision .view-for-select .form-control.custom {
        width: 53%
    }
}

.PCPErrorMsg {
    border-top: 3px solid;
    border-top-color: red;
    background: #eee
}

.notetxt {
    border: none;
    background: #fff;
    padding: 10px;
    margin: 10px 0
}

.restrictiontext {
    color: #a94442;
    margin-left: 8.2%;
    padding-top: 3%
}

.p-t-3 {
    padding-top: 3%
}

.noborder {
    border: 0 !important
}

.coverage-panelBody .accordion-grid-content p {
    margin: 15px 20px
}

.collapse-viewfor.open:before {
    background: url(https://member.aetna.com/secure/member/images/collapse_all.png) no-repeat
}

.pcp-coverage-block {
    border: 1px solid #ccc;
    box-shadow: 0 0 3px #ccc;
    padding: 15px;
    margin-top: 20px
}

.pcp-namecontent {
    margin: 15px 0
}

.pcp-namecontent h2 {
    font-size: 24px
}

.pcp-dateContent .span-block {
    display: block
}

.benifits_journey .coverage-div h2 {
    font-size: 18px;
    font-weight: 700;
    margin-top: 10px
}

.benifits_journey .rightSec h4 {
    font-weight: 700
}

.coverage-pleats-add {
    margin-left: 2px
}

.behavioral {
    margin: 20px 0
}

ul.bulletType_disc_coverage {
    padding-left: 15px
}

ul.bulletType_disc_coverage,
ul.bulletType_disc_coverage li {
    list-style: disc outside none
}

.rightSec a {
    font-weight: 700
}

.memberSelectorPannel {
    background-color: #fff
}

#headingTen .panelTitle-text,
div.panelText .panelTitle-text {
    color: #000 !important
}

#tab10 .col-xs-3.pad0,
#tab10 .col-xs-6.pad0 {
    border-right: 1px solid #ccc;
    min-height: 46px
}

#tab10 img,
.findBulletin img {
    margin: 0 8px 0 4px;
    vertical-align: text-top
}

.summerySection .benifit-medical-name {
    font-size: 18px;
    color: #000;
    font-weight: 700
}

.topMrgn30 {
    margin-top: 30px
}

h4.benifit-medical-name a {
    font-size: 16px;
    margin-left: 20px
}

.progress {
    margin-bottom: 5px;
    margin-top: 5px;
    height: 24px;
    border-radius: 10px;
    box-shadow: inset 0 1px 2px 0 hsla(0, 0%, 71%, .49);
    background: #fff
}

.findBulletin {
    border-top: 2px solid #ccc;
    margin-top: 15px;
    padding-top: 10px !important
}

.infogram-decuctible {
    padding: 0 0 10px
}

.progress-bar.gray {
    background: #4b65ae
}

.progress-bar {
    border-radius: 10px;
    margin: 3px;
    height: 18px
}

.coverage-result-div .progress {
    height: 30px;
    border-radius: 20px
}

.coverage-result-div .progress-bar {
    margin: 6px;
    height: 18px;
    margin-top: 6px
}

.sm-network {
    font-size: 12px;
    margin-left: 20px;
    color: #4e7d2a;
    font-weight: 700
}

.infogram-decuctible p {
    margin-bottom: 0
}

.top-mrgn {
    margin-top: 30px
}

#tab16 p a img {
    margin: 0 5px
}

.secondrow .annualDed {
    margin-top: 66px
}

.rightSec {
    margin: 35px 0 20px;
    background-color: #eee;
    padding: 10px 15px
}

.m-b-20,
.rightSec p {
    margin-bottom: 20px
}

.annualDed {
    background-color: #fff;
    padding: 10px;
    margin-top: 35px;
    font-size: 14px;
    box-shadow: 0 2px 10px 0 #9e9e9e
}

.annualDed b {
    font-size: 22px
}

.inline {
    display: inline-block
}

.bg-white {
    background-color: #fff;
    border: 1px solid #ccc;
    margin: 0 0 30px
}

.top.pull-right {
    margin: 10px
}

.tblcell {
    display: table-cell;
    color: #076f86;
    font-size: 14px;
    text-align: center
}

.tblLinksCell {
    display: table-cell;
    color: #7d3f98;
    font-size: 16px;
    text-align: left;
    padding-left: 10px
}

.col-xs-3.pad0 a,
.col-xs-6.pad0 a {
    display: table
}

.coverage-overview .aet-content-fluid {
    margin: 0 auto;
    padding-left: 15px
}

.coverage-overview ul li {
    margin: 0 4px
}

.coverage-overview ul li a {
    display: block;
    width: 100%
}

.coverage-div {
    color: #fff
}

.bottom-top1 {
    border-top: 3px solid #69747a
}

.coverage-div p,
.font-white {
    color: #fff
}

.dental-coverage {
    background-color: #7d3f98;
    border: 3px solid #7d3f98 !important
}

.dental-coverage-new {
    border-color: #7d3f98;
    background-color: #fff;
    border-width: 1px 1px 1px 8px;
    border-style: solid;
    color: #000
}

.dental-coverage p,
.health-coverage p,
.medical-coverage p,
.pharmacy-coverage p,
.vision-coverage p {
    margin-left: 2px
}

.dental-coverage-border {
    border-top-color: #7d3f98
}

.panel-group.dental .panel-heading {
    background-color: #7d3f98
}

.coverage-p {
    color: #fff !important
}

.medical-coverage {
    background-color: #7d3f98;
    border: 3px solid #7d3f98 !important
}

.medical-coverage-new {
    border-color: #7d3f98;
    background-color: #fff;
    border-width: 1px 1px 1px 8px;
    border-style: solid;
    color: #000
}

.medical-coverage-border {
    border-top-color: #7d3f98
}

.panel-group.medical .panel-heading {
    background-color: #7d3f98
}

.coverage-p-new {
    color: #000 !important
}

.health-coverage {
    background-color: #7d3f98;
    border: 3px solid #7d3f98 !important
}

.health-coverage-new {
    border-color: #7d3f98;
    background-color: #fff;
    border-width: 1px 1px 1px 8px;
    border-style: solid;
    color: #000
}

.health-coverage-border {
    border-top-color: #7d3f98
}

.panel-group.behavioral .panel-heading,
.panel-group.health .panel-heading {
    background-color: #7d3f98
}

.pharmacy-coverage {
    background-color: #4b65ae;
    border: 3px solid #4b65ae !important
}

.pharmacy-coverage-new {
    border-color: #7d3f98;
    background-color: #fff;
    border-width: 1px 1px 1px 8px;
    border-style: solid;
    color: #000
}

.panel-group.pharmacy .panel-heading {
    background-color: #7d3f98
}

.pharmacy-coverage-border {
    border-top-color: #7d3f98
}

.additional-coverage {
    background-color: #7d3f98;
    border: 3px solid #7d3f98 !important
}

.additional-coverage-border {
    border-top-color: #7d3f98
}

.additional-coverage-new {
    border-color: #7d3f98;
    background-color: #fff;
    border-width: 1px 1px 1px 8px;
    border-style: solid;
    color: #000
}

.helpful_information .medical .helpfulapp {
    color: #1d7564 !important;
    font-size: 12px;
    font-weight: 700
}

.helpful_information .dental .helpfulapp {
    color: #4e7d2a !important;
    font-size: 12px;
    font-weight: 700
}

.helpful_information .behavioral .helpfulapp,
.helpful_information .health .helpfulapp {
    color: #4b65ae !important;
    font-size: 12px;
    font-weight: 700
}

.helpful_information .vision .helpfulapp {
    color: #1b7fcf !important;
    font-size: 12px;
    font-weight: 700
}

.helpful_information .pharmacy .helpfulapp {
    color: #4b65ae !important;
    font-size: 12px;
    font-weight: 700
}

.helpful_information .additional .helpfulapp {
    color: #526f83 !important;
    font-size: 12px;
    font-weight: 700
}

.panel-group.additional .panel-heading {
    background-color: #7d3f98
}

.coverage-overview {
    background-color: #eee;
    padding: 15px 0
}

.coverage-heading {
    color: #406622;
    font-size: 18px;
    font-weight: 700;
    padding-right: 25px;
    display: inline-block
}

.coverage-idcard,
.pleat-idcard {
    font-weight: 700
}

.pleat-idcard {
    float: center
}

#viewFor1 {
    width: 32%;
    margin-left: 25px
}

#viewFor,
#viewFor1,
#viewFor2,
#viewFor3,
#viewFor4,
#viewFor5,
#viewFor6,
#viewFor7,
#viewFor8,
#viewFor9,
#viewFor10,
#viewFor11 {
    display: inline-block
}

.coverage-result-div .aet-content-fluid {
    padding-left: 15px
}

.view-for-select {
    float: left;
    width: 50%
}

.view-for {
    margin-top: 25px;
    overflow: auto;
    margin-bottom: 25px
}

.form-group #viewFor {
    width: 100%;
    margin-left: 0
}

.expand-collapse-med {
    margin: 5px 0 5px -38px
}

.view-for-collapse {
    text-align: right
}

.view-addl-cov {
    margin-left: -19px
}

.expand-collapse {
    margin: 20px 0 0 -25px
}

.view-for-addl-cov span,
.view-for-collapse span {
    color: #1c8ba6;
    font-weight: 700
}

.collapse-viewfor {
    margin-left: 20px
}

.accordionFindings {
    padding: 15px
}

.accordion-grid-header {
    overflow: auto;
    clear: both;
    height: 100%;
    background-color: #eee;
    padding-right: 15px;
    padding-left: 15px;
    font-weight: 700;
    padding: 0
}

.gridContent,
.gridHeading {
    padding: 15px 17px
}

.no-padding-right,
.rightSplit div:last-child div:last-child {
    padding-right: 0
}

.rightSplit div:first-child div:first-child a {
    display: block
}

.maternity-care,
.read-more-link {
    display: inline-block !important;
    font-weight: 700
}

.accordion-grid-content-row {
    overflow: hidden
}

.leftSplit,
.rightSplit {
    border-top: 1px solid #ccc
}

.mergedRow .rightSplit {
    border-left: 1px solid #ccc
}

.accordion-grid-content-row:first-child .leftSplit,
.accordion-grid-content-row:first-child .rightSplit,
.noBorderTop {
    border-top: none !important
}

.accordion-grid-content-row:last-child,
.bottom-border {
    border-bottom: 1px solid #ccc
}

.accordion-grid-content {
    clear: both;
    overflow: hidden
}

.panel-group .panel+.panel {
    margin-top: -1px
}

.estimate,
.highlight {
    color: #076f86;
    font-weight: 700;
    cursor: pointer
}

.coverage-panelBody {
    padding: 0
}

.benifit-medical-name {
    font-size: 20px;
    color: #4e7d2a
}

@media screen and (max-width:767px) {
    .navbar-toggle {
        display: block !important
    }

    .benifit-medical-name,
    .coverage-heading {
        font-size: 16px
    }

    .coverage-div {
        height: 60px !important
    }

    #tab2 .accordionFindings span {
        width: 44% !important
    }

    #tab3 .accordionFindings span {
        width: 17% !important
    }

    #tab9 .accordionFindings span {
        width: 30% !important
    }

    #viewFor,
    #viewFor2,
    #viewFor3,
    #viewFor4,
    #viewFor5,
    #viewFor6,
    #viewFor7,
    #viewFor8,
    #viewFor9,
    #viewFor10,
    #viewFor11 {
        padding-right: 51px
    }

    h4.col-sm-12.font-head.benifit-medical-name.pad0 {
        width: 45%
    }

    .txt-right {
        width: 40%
    }

    .bg-white {
        margin: 60px 0 30px
    }
}

.expand-collapse-med .collapse-viewfor {
    display: inline-block
}

@media screen and (max-width:768px) {
    .SBC #LinkSBC span.plus_minus {
        width: 5%
    }

    .SBC #LinkSBC span.panelTitle-text {
        width: 91%
    }
}

.Pleats_CNB_medical .panel-group.indicator_right .plus_minus {
    background-position: 100%;
    float: none;
    margin-right: 12px
}

@media screen and (max-width:991px) {
    .col-sm-12.col-md-3.pad0.col-xs-12 {
        border-top: 2px solid #ccc;
        margin: 10px 0
    }

    .col-sm-12.col-md-3.pad0.col-xs-12 .col-xs-6.pad0,
    .m-t-15 {
        margin-top: 15px
    }

    .notetxt a img {
        margin: 0 5px
    }

    .pharmacy-sce .accordion-grid-content-row:last-child {
        border-bottom: none !important
    }

    #tab10 img {
        vertical-align: top
    }

    #additional .view-for-addl-cov,
    #additional .view-for-collapse {
        float: right;
        width: 35%;
        clear: none;
        margin-top: 0;
        padding-top: 0
    }

    #additional .view-for-addl-cov span:first-child,
    #additional .view-for-collapse span:first-child {
        width: 80%;
        text-align: right
    }

    #additional .heading-idcard {
        margin: 25px 0 0 10px
    }

    #tab10 .col-xs-3.pad0,
    #tab10 .col-xs-6.pad0 {
        border-right: 0
    }

    .mobHeading.hidden-md.hidden-lg.bold {
        color: #000
    }

    .col-xs-2.leftSplit {
        font-weight: 700
    }

    .coverageSubtext {
        font-weight: 400;
        font-size: 15px
    }

    .gridContent {
        padding: 5px 15px
    }

    .panel-title img {
        width: 26px;
        height: 27px
    }

    .mergedRow .rightSplit {
        border-left: none
    }

    .coverage-div {
        height: 90px;
        margin-right: 1%;
        margin-left: 1%;
        padding-left: 0;
        text-align: center;
        padding-right: 0
    }

    .coverage-overview {
        background-color: #fff
    }

    .benifits_journey .coverage-div h2 {
        font-size: 14px;
        text-align: center
    }

    .coverage-result-div .aet-content-fluid {
        padding-left: 10px
    }

    .coverage-heading {
        display: inline-block
    }

    .coverage-idcard {
        width: 38%;
        text-align: right
    }

    #viewFor {
        width: 70%
    }

    .view-for-select {
        width: 50%
    }

    .view-for-addl-cov span:first-child,
    .view-for-collapse span:first-child {
        display: inline-block;
        float: left;
        width: 93%
    }

    .collapse-viewfor {
        display: inline-block
    }

    .accordionFindings span {
        display: inline-block;
        width: 50%;
        font-size: 14px;
        color: #000
    }

    .accordionFindings button {
        float: right;
        font-size: 13px
    }

    .heading {
        font-weight: 700
    }

    .accordionFindings {
        float: none !important;
        overflow: hidden
    }

    .coverage-idcard {
        float: right;
        overflow: auto;
        text-align: left;
        font-size: 16px;
    }

    .panel.panel-default {
        font-size: 14px;
    }

    .annualDed,
    .secondrow .annualDed {
        margin-top: 0
    }

    .summerySection.clearfix {
        padding-right: 1px;
    }

    .infogram-coinsurance,
    .infogram-decuctible {
        width: 50%;
        float: left;
        padding-bottom: 15px;
        margin: 0 !important;
    }

    .right-content {
        width: 50%;
        float: right;
        top: 37px;
        padding: 0 0 0 10px;
    }

    h4.col-sm-12.font-head.benifit-medical-name.pad0 {
        font-size: 16px;
        float: left;
    }

    .panel-group .panel-heading span,
    .txt-right {
        font-size: 15px;
    }

    .txt-right {
        float: right;
        margin: 10px 0;
        line-height: 17px
    }

    .col-sm-3.pad0.col-xs-12 {
        border-top: 2px solid #ccc;
        margin: 10px 0
    }

    .col-sm-3.pad0.col-xs-12 .col-xs-6.pad0 {
        margin: 10px 0 0
    }

    h2.col-sm-12.font-head.benifit-medical-name.pad0 {
        width: 100%
    }

    #viewFor1 {
        width: 75%;
        margin-left: 0
    }

    .behav-health .coverage-heading {
        width: 100%
    }

    .behav-health .annualDed,
    .behav-health .secondrow .annualDed {
        margin-top: 12px
    }
}

@media screen and (max-width:400px) {
    .benifits_journey .coverage-div h2 {
        font-size: 12px
    }

    label.col-xs-2.pad0.control-label {
        font-size: 14px
    }

    .SBC #LinkSBC span.plus_minus {
        width: 5%
    }

    .SBC #LinkSBC span.panelTitle-text {
        width: 89%
    }

    span.m-b-SBC {
        margin-bottom: 30px
    }

    span.m-b-11 {
        margin-bottom: 11%
    }

    span.m-b-22 {
        margin-bottom: 22%
    }

    .pad-l-4 {
        padding: 0 0 0 11.3% !important
    }
}

@media screen and (max-width:767px) {
    .view-for-select {
        width: 100%;
        margin-bottom: 10px
    }
}

@media screen and (min-width:768px) {
    .coverage-overview ul li {
        margin: 0 12px
    }

    .right-content {
        width: 30%;
        top: -81px;
        padding: 0 16px 0 0
    }

    .infogram-coinsurance,
    .infogram-decuctible {
        width: 70%;
        float: left;
        padding-bottom: 15px;
        margin: 0 !important
    }

    .pharmacy-sce .accordion-grid-content-row:last-child {
        border-bottom: none !important
    }

    .getCost {
        border-left: 1px solid #ccc;
        padding: 16px
    }

    .top.pull-right {
        margin: 20px 0
    }

    .no-mob-border {
        border: none !important
    }
}

.rightborder {
    border-right: 1px solid #7d3f98 !important
}

@media screen and (min-width:992px) {
    .col-xs-12.pad0.findBulletin {
        border-top: 1px solid #ccc
    }

    .summerySection .col-sm-3.col-md-2 {
        width: 20.666667%
    }

    .coverage-overview ul li {
        margin: 0 15px
    }

    .notetxt a img {
        margin: 0 5px
    }

    .right-content {
        width: 25%;
        top: 23px
    }

    .notetxt br {
        display: none
    }

    h4.col-sm-12.font-head.benifit-medical-name.pad0 {
        width: 44%
    }

    a.txt-right.clearfix {
        margin: 9px 0;
        display: inline-block;
        font-weight: 700
    }

    .behav-health .annualDed {
        margin-top: 9px
    }

    .behav-health .secondrow .annualDed {
        margin-top: 56px
    }

    .link-display {
        float: right;
        padding-right: 1px;
        font-weight: 700;
        padding-top: 1px;
        margin-left: 2px
    }

    .top-mrgn10 {
        margin-top: 10px
    }

    .getCost {
        height: 75px
    }

    .benefitCards div.aet-content-hdrtxt h1.no-margin-left,
    .no-margin-left,
    ul li a span.font-16 {
        margin-left: 0 !important
    }
}

@media screen and (max-width:768px) {
    .panel-group .panel-heading span {
        color: #fff;
        font-size: 17px
    }
}

.arrowIndicator {
    content: "";
    position: absolute;
    margin-left: -13px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 13px 13px;
    z-index: 1;
    margin-top: 2px
}

.blue-arrow {
    background: url(https://member.aetna.com/secure/member/images/blue_arrow.png) no-repeat 0 0;
    display: inline-block;
    width: 11px;
    height: 9px
}

.panel-group .panel-heading a .sign_plus {
    background-image: url(https://member.aetna.com/secure/member/images/plus.png);
    background-repeat: no-repeat;
    padding: 0 15px;
    height: 30px
}

.panel-group .panel-heading a .plus_minus {
    background-image: url(https://member.aetna.com/secure/member/images/minus.png);
    background-repeat: no-repeat;
    padding: 0 11px;
    height: 30px
}

.collapse-viewfor:before {
    background: url(https://member.aetna.com/secure/member/images/expand_all_icon.png) no-repeat
}

.collapse-viewfor:before,
.expand-viewfor {
    content: "";
    color: #076f86;
    font-size: 20px;
    margin: 0 4px;
    padding-left: 22px
}

.expand-viewfor {
    background: url(https://member.aetna.com/secure/member/images/collapse_all.png) no-repeat;
    float: right
}

.no-margin {
    margin: 0 !important
}

.m-r-5 {
    margin-right: 5px
}

.marL5 {
    margin-left: 5px
}

.Expand-Collapse-label {
    font-size: 16px;
    font-weight: 400;
    font-family: calibri
}

.m-l-5 {
    margin-left: 5px
}

div.coverage-overview ul.navigation li p {
    bottom: -5px;
    position: absolute
}

.vision-coverage {
    background-color: #1b7fcf;
    border: 3px solid #1b7fcf !important
}

.vision-coverage-new {
    border-color: #1b7fcf;
    background-color: #fff;
    border-width: 1px 1px 1px 8px;
    border-style: solid;
    color: #000
}

.panel-group.vision .panel-heading {
    background-color: #7d3f98 !important
}

.vision-coverage-border {
    border-top-color: #1b7fcf
}

.animate-linear {
    transition: all 1s linear
}

.right-border {
    border-right: 1px solid #ccc !important
}

.p-10 {
    padding: 10px
}

.p-15 {
    padding: 15px
}

.m-b-10 {
    margin-bottom: 10px
}

.p-t-15 {
    padding-top: 15px
}

.p-b-30 {
    padding-bottom: 30px
}

div.no-padding,
span.no-padding {
    padding: 0 !important
}

@-moz-document url-prefix() {
    .auto-height {
        height: auto !important
    }
}

.height-auto {
    height: auto !important
}

.noTop,
.noTopIE {
    top: auto
}

@media screen and (max-width:320px) {
    .coverage-overview ul li a {
        width: 60px
    }

    .coverage-overview ul li {
        margin: 0 1.5%
    }
}

.bold {
    font-weight: 700 !important
}

div#additional_coverage .coverage-accordian .panel-group .panel .panel-heading a.collapsed,
div#behavioral .coverage-accordian .panel-group .panel .panel-heading a.collapsed,
div#dentals .coverage-accordian .panel-group .panel .panel-heading a.collapsed,
div#medicals .coverage-accordian .panel-group .panel .panel-heading a.collapsed,
div#pharmacy .coverage-accordian .panel-group .panel .panel-heading a.collapsed,
div#vision .coverage-accordian .panel-group .panel .panel-heading a.collapsed {
    background-color: #fff !important;
    border: 1px
}

div#additional_coverage .coverage-accordian .panel-group .panel,
div#behavioral .coverage-accordian .panel-group .panel,
div#dentals .coverage-accordian .panel-group .panel,
div#medicals .coverage-accordian .panel-group .panel,
div#pharmacy .coverage-accordian .panel-group .panel,
div#vision .coverage-accordian .panel-group .panel {
    margin-bottom: 20px !important;
    border: 1px solid #d9d9d9 !important
}

.coverage-div {
    height: 120px;
    border-style: solid;
    border-width: 1px 1px 1px 8px;
    position: relative;
    overflow: hidden
}

.coverage-div:before {
    content: "";
    position: absolute;
    left: -24%;
    top: -50%;
    width: 0;
    height: 200%;
    opacity: 0
}

.green .coverage-div:before {
    background-color: #4e7d2a
}

.canbPink .coverage-div:before {
    background-color: #d20962
}

.anchorBlue .coverage-div:before {
    background-color: #1d7564
}

.purpuleShade .coverage-div:before {
    background-color: #7d3f98
}

.blue .coverage-div:before {
    background-color: #4b65ae
}

.darkerGray .coverage-div:before {
    background-color: #526f83
}

.navyblue .coverage-div:before {
    background-color: #1b7fcf
}

.coverage-div:hover:before,
li a:focus .coverage-div:before {
    width: 150%;
    opacity: 1;
    transition: .55s;
    -moz-transition: .55s;
    -webkit-transition: .55s;
    -ms-transition: .55s;
    -o-transition: .55s
}

.coverage-div h2,
.coverage-div p {
    color: #000;
    position: absolute
}

.coverage-div p {
    bottom: -5px
}

.coverage-div:hover h2,
.coverage-div:hover p,
li a:focus .coverage-div h2,
li a:focus .coverage-div p {
    color: #fff;
    transition: .25s;
    -moz-transition: .25s;
    -webkit-transition: .25s;
    -ms-transition: .25s;
    -o-transition: .25s
}

.covered {
    background-color: #fff;
    color: #000;
    text-align: center;
    width: 50%;
    position: absolute;
    bottom: 0;
    margin-bottom: 15px
}

.green .coverage-div {
    border-color: #4e7d2a
}

.anchorBlue .coverage-div {
    border-color: #1d7564
}

.purpuleShade .coverage-div {
    border-color: #7d3f98
}

.blue .coverage-div {
    border-color: #4b65ae
}

.darkerGray .coverage-div {
    border-color: #526f83
}

.navyblue .coverage-div {
    border-color: #1b7fcf
}

.active.green .coverage-div {
    background-color: #4e7d2a
}

.active.anchorBlue .coverage-div {
    background-color: #1d7564
}

.active.purpuleShade .coverage-div {
    background-color: #7d3f98
}

.active.blue .coverage-div {
    background-color: #4b65ae
}

.active.darkerGray .coverage-div {
    background-color: #526f83
}

.active.canbPink .coverage-div {
    background-color: #d20962
}

.active .coverage-div h2,
.active .coverage-div p {
    color: #fff
}

.active.navyblue .coverage-div {
    background-color: #1b7fcf
}

.font-bold {
    font-weight: 700 !important
}

.pharmacyTile {
    background-color: #7d3f98 !important
}

.pharmacyTileText {
    color: #fff !important;
    font-size: 20px !important
}

.m-l-15 {
    margin-left: 15px
}

.m-t-10 {
    margin-top: 10px
}

.pad-l-2-7 {
    padding-left: 2.7%
}

.width-20 {
    width: 20% !important
}

.text-left {
    text-align: left
}

.SBH:before {
    margin: 0 4px 1px 0 !important
}

.p-t-6 {
    padding-top: 6px
}

.p-l-1 {
    padding-left: 1.5% !important
}

@media screen and (max-width:500px) {
    .coverage-div {
        border-width: 1px 1px 1px 4px
    }

    .mob-border {
        border: 1px solid #ccc !important
    }

    .rightborder1 {
        border: none !important;
    }
}

/* @media screen and (max-width:991px) .coverage-idcard { */
@media screen and (max-width:991px) {.coverage-idcard {
    float: left;
    overflow: auto;
    text-align: left;
    font-size: 16px
}
}

@media screen and (max-width:991px) {.scrollToContant {
    float: left
}}

.icon-block-purple {
    background: #7d3f98;
    padding: 5px 6px;
    border-radius: 20px
}

.Padding-Icon {
    padding: 10px 0 13px
}

.no-margin-bottom {
    margin-bottom: 0
}

.activity-page-header {
    font-size: 18px
}

@media screen and (min-width:1200px) {
    .dollar-val-align {
        float: right;
        padding-right: 72px
    }

    .dollar-val-align-applied {
        float: right;
        padding-right: 152px
    }

    .sub-charge-det {
        float: right;
        padding-right: 59px
    }

    .wellMatch-align {
        padding-left: 37px;
        padding-right: 191px
    }
}

@media screen and (min-width:710px) and (max-width:1199px) {
    .dollar-val-align {
        padding-left: 47px
    }

    .dollar-val-align-applied {
        padding-left: 10px
    }
}

.rightborder1 {
    border-right: 1px solid #ccc
}

@media screen and (max-width:709px) {
    .dollar-val-align {
        padding-left: 15px
    }

    .dollar-val-align-applied {
        padding-left: 10px
    }

    .dollar-val-div-align,
    .p-t-10 {
        padding-top: 10px !important
    }
}

.mobile-act-details {
    display: block;
    background-color: #fff;
    color: #000;
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    border-left: 1px solid #ccc;
    padding-right: 53px
}

@media screen and (min-width:451px) {
    .mobile-activity-det-view {
        display: none
    }

    .pad-l-4 {
        padding-left: 3.3%
    }
}

@media screen and (max-width:450px) {
    .desktop-activity-det-view {
        display: none
    }
}

.headClass-Select {
    color: #000 !important;
    font-size: 16px
}

.headClass {
    color: #fff !important;
    font-size: 16px
}

@media screen and (max-width:991px) {
    .mobile-activity-details {
        display: none
    }
}

@media screen and (max-width:991px) {
    .mobile-activity-table {
        text-align: left
    }
}

@media screen and (max-width:991px) {
    .mobile-plan-details-text {
        margin-left: -10px
    }
}

.link-style {
    cursor: pointer;
    color: #23527c
}

.mobile-activity-details-link {
    margin-left: 4px
}

.activity-detail-page {
    background-color: #eee
}

@media screen and (min-width:991px) {
    .mobile-activity-PD-view {
        display: none
    }
}

@media screen and (max-width:990px) {
    .desktop-activity-PD-view {
        display: none
    }
}

.note_image {
    background: #7d3f98;
    padding: 5px 6px;
    border-radius: 20px
}

@media only screen and (min-device-width:361px) and (max-device-width:667px) and (-webkit-min-device-pixel-ratio:2) {
    .padding-SM {
        padding: 0 43px 0 5px
    }

    .img_iphone6 {
        margin: 0 0 0 10px !important
    }

    .go_paperless_iph6 {
        font-weight: 800 !important;
        font-size: 14px !important;
        padding-right: 6px !important;
        color: #556b2f !important;
        margin-left: 2px !important
    }

    .turn_paper_off {
        font-weight: 400 !important;
        margin: 0 4px 0 -8px !important;
        font-size: 14px !important
    }

    .view_your_statements {
        padding-bottom: 11px !important;
        font-size: 14px !important;
        margin: 0 0 0 11px !important;
        width: 97% !important
    }
}

@media only screen and (min-device-width:320px) and (max-device-width:359px) and (-webkit-min-device-pixel-ratio:2) {
    .padding-SM {
        padding: 0
    }

    .img_iphone5 {
        margin: 0 0 0 10px !important
    }

    .go_paperless_iph5 {
        font-weight: 700 !important;
        font-size: 13px !important;
        padding-right: 6px !important;
        color: #556b2f !important;
        margin-left: -2px !important
    }

    .turn_paper_off5 {
        font-weight: 400 !important;
        margin: 0 4px 0 -6px !important;
        font-size: 13px !important
    }

    .view_your_statements5 {
        padding-bottom: 11px !important;
        font-size: 13px !important;
        margin: 0 0 0 12px !important;
        width: 97% !important
    }
}

@media only screen and (min-device-width:412px) and (max-device-width:767px) and (-webkit-min-device-pixel-ratio:2) {
    .padding-SM {
        padding: 0 30px 0 5px
    }

    .img_iphone6pl {
        margin: 0 0 0 10px !important
    }

    .go_paperless_iph6pl {
        font-weight: 700 !important;
        font-size: 16px !important;
        padding-right: 6px !important;
        color: #556b2f !important;
        margin-left: 3px !important
    }

    .turn_paper_off_iph6pl {
        font-weight: 400 !important;
        margin: 0 4px 0 -12px !important;
        font-size: 16px !important;
        padding-left: 6px
    }

    .view_your_statements_iph6pl {
        padding-bottom: 11px !important;
        font-size: 16px !important;
        margin: 0 0 0 11px !important;
        width: 97% !important
    }
}

@media only screen and (min-device-width:768px) and (max-device-width:1024px) and (-webkit-min-device-pixel-ratio:1) {
    .img_ipad {
        margin: 0 0 0 10px !important
    }

    .go_paperless_ipad {
        font-weight: 800 !important;
        color: #556b2f !important
    }

    .turn_paper_off_ipad {
        font-weight: 500 !important;
        margin: 0 0 0 3px !important
    }

    .view_your_statements_ipad {
        margin: 0 0 0 3px !important;
        font-size: 16px
    }
}

.progress-Bar-Width {
    width: 330px
}

.margin-Vision {
    margin-left: 10px
}

.margin-vision-header {
    margin: 10px 0 10px 10px
}

.turn-paper-off-desktopImageMargin {
    margin: 0 0 0 13px !important
}

.GoPaperlessDesktop {
    font-weight: 800;
    color: #556b2f
}

.turnPaperOffurlDesktop {
    font-weight: 500;
    margin-left: 7px
}

.visit24-7-Desktop {
    margin: 0 0 0 3px
}

.visitHealthCare {
    font-weight: 500;
    margin: 10px 0 10px 13px
}

.imgExternalLink {
    margin: 3px 0 0 !important
}

@media screen and (max-width:769px) {
    .fin-head {
        padding-top: 0
    }
}

@media screen and (min-width:770px) {
    .fin-head {
        padding-top: 10px
    }
}

.covBen_pleats_title {
    font-size: 16px;
    font-weight: 700
}

.summary-benefits-before {
    padding-top: 9px
}

.p-t-17,
.summary-benefits-after-help {
    padding-top: 17px !important
}

.no-decoration {
    text-decoration: none !important
}

.margin-2 {
    margin: 2px !important
}

.view-medical-plans {
    margin-right: 1px !important
}

.pad-change-doc {
    padding-top: 4px
}

.breakWord {
    word-wrap: break-word
}

@media screen and (min-width:400px) and (max-width:500px) {
    .coverage-overview ul li.col-xs-2 {
        width: 18%;
        margin: 0 3px
    }
}

.bot-margin {
    padding-bottom: 12px
}

.rbp-top-block {
    border: 1px solid #ccc;
    box-shadow: 0 0 3px #ccc;
    padding: 15px;
    margin-top: 20px;
    margin-left: 15px;
    margin-right: 45px;
    position: relative
}

.rbp-facilities-block {
    margin-top: 20px;
    margin-right: 60px;
    position: relative
}

#memberDropDown {
    display: inline-block;
    width: 82%
}

.facilityTableCode {
    font-size: 8px
}

.pt-10 {
    padding: 10px 0
}

.panel-group .panel-heading a.collapsed .plus_minus:after {
    top: 7px;
    right: 1px
}

.panel-group .panel-heading a.collapsed .plus_minus {
    background-image: url(https://member.aetna.com/secure/member/images/plus.png);
    right: 0;
    top: 5px
}

.panel-group .panel-heading a#LinkSBC .plus_minus,
.panel-group .panel-heading a.Additional_Products .plus_minus {
    background-image: url(https://member.aetna.com/secure/member/images/plus.png);
    right: 5px;
    top: 5px
}

@-moz-document url-prefix() {
    .panel-group .panel-heading a.collapsed .plus_minus:after {
        top: 12px !important;
        right: 1px !important
    }

    .panel-group .panel-heading a.collapsed .plus_minus {
        background-image: url(https://member.aetna.com/secure/member/images/plus.png) !important;
        right: 0 !important;
        top: 0 !important
    }

    .panel-group .panel-heading a.collapsed .plus_minus:before {
        top: 4px !important
    }
}

sup {
    top: .1em !important;
    font-size: 24px !important
}

.no-margin-top {
    margin-top: 0 !important
}

.f-right,
.text-right {
    float: right !important
}

.p-l-28 {
    padding-left: 28px !important
}

.displayTextInline {
    display: inline
}

.coverage-selected {
    background-color: #7d3f98;
    border: 3px solid #7d3f98 !important
}

.coverage-default {
    border-color: #b18cc1;
    background-color: #b18cc1;
    border-width: 1px 1px 1px 8px;
    border-style: solid;
    color: #000
}

.coverage-tile {
    height: 120px;
    border-style: solid;
    border-width: 1px;
    position: relative;
    overflow: hidden
}

.coverage-selected,
.coverage-selected p {
    color: #fff
}

.downArrowIndicator {
    content: "";
    position: absolute;
    margin-left: -13px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 11px 6px;
    z-index: 1;
    transform: rotate(180deg);
    border-color: transparent transparent #7d3f98
}

.tileBottom {
    border: 1px solid #7d3f98
}

.m-t-3 {
    margin-top: 3px
}

.benefitNote {
    background: #fff
}

.activityNote,
.benefitNote {
    border: 1px solid #d9d9d9;
    padding: 10px;
    margin: 10px 0
}

.CNB_MODULE .coverage-tile h2,
.m-t-8 {
    margin-top: 8px !important
}

.benefitCards select,
.CNB_MODULE select {
    border-color: #d9d9d9 !important
}

.Pleats_CNB_medical .tile_seperator span {
    font-size: 16px;
    color: #7d3f98 !important;
    font-weight: 400
}

.Pleats_CNB_medical .nav-tabs>li a {
    border: none;
    padding: 15px 9px 0 7px
}

.Pleats_CNB_medical .nav-tabs li {
    margin-bottom: 1%
}

.Pleats_CNB_medical .nav-tabs>li a img {
    border-radius: 0
}

.p-t-7 {
    padding-top: 7px
}

.Pleats_CNB_medical ul.nav-tabs {
    border-bottom: none !important;
    padding: 0;
    background-color: #eee
}

.benefitNote span {
    color: #7d3f98 !important
}

.Pleats_CNB_medical .nav-tabs .home_group {
    border: 2px solid #d9d9d9 !important;
    box-shadow: 0 0 0 #d9d9d9
}

.CNB_MODULE .memberDropDownBox {
    border: 1px solid #d9d9d9;
    background: #fff;
    padding: 10px;
    margin: 0 0 30px
}

.CNB_MODULE ul li {
    margin: 0 15px 0 0
}

@media (min-width:768px) {
    #main-div .coverageContainer {
        width: auto !important
    }
}

@media (min-width:1200px) {
    #main-div .coverageContainer {
        width: 1308px !important
    }
}

.coverage-result-div .container .aet-content-fluid {
    max-width: 100% !important;
    padding-left: 0 !important
}

.p-t-13 {
    padding-top: 13px
}

.p-t-1 {
    padding-top: 1px
}

.font-normal {
    font-weight: 400
}

@media screen and (min-width:1281px) {
    .Pleats_CNB_medical ul li .HILBMenu {
        width: 110%;
        padding-left: 12px !important
    }
}

.planBalanceHeading,
.progress-bar.pink {
    background: #7d3f98 !important
}

.dedAmount {
    padding-left: 0;
    margin-bottom: 15px
}

.p-t-5 {
    padding-top: 5px !important
}

.p-l-6 {
    padding-left: 6px
}

.finNote {
    border: 1px solid #ccc;
    background: #f8f8f8;
    padding: 10px;
    margin: 15px 0
}

.panel-group.anchorBlue .panel-heading a {
    background: #7d3f98
}

.additional-coverage {
    background-color: #b18cc1;
    border: 3px solid #b18cc1 !important
}

.leftFloat {
    float: left
}

.p-r-6 {
    padding-right: 6px
}

.pleatsBox {
    border-top: 2px solid #7d3f98 !important;
    background: #fff;
    padding: 0;
    margin: 15px 6px;
    border-bottom: 2px solid #d9d9d9;
    border-left: 2px solid #d9d9d9;
    border-right: 2px solid #d9d9d9
}

.p-l-9 {
    padding-left: 9%
}

.p-12 {
    padding: 12px !important
}

.no-padding-left {
    padding-left: 0 !important
}

.cursorPointer {
    cursor: pointer
}

.RollupDetail {
    width: 98% !important
}

.RollupBoxes {
    width: 50% !important;
    float: left
}

.activityDetails .activityNote span,
.medicalPlanContainer .benefitNote span {
    color: #414141 !important;
    font-size: 14px !important
}

.activityDetails span.linkColor {
    color: #7d3f98 !important
}

.no-border {
    border: none !important
}

.tblBorder {
    border: 1px solid #d9d9d9 !important
}

.Pleats_CNB_medical li.home_group:hover {
    background-color: #eee !important
}

.Pleats_CNB_medical li.home_group p.HILBMenu {
    margin-left: -4% !important
}

.p-5 {
    padding: 5px
}

.evenRows {
    background-color: #f4f4f4
}

.p-l-4 {
    padding-left: 4%
}

.p-l-3 {
    padding-left: 3%
}

.full-width {
    width: 100% !important
}

.m-l-14 {
    margin-left: 14%
}

.oddRows {
    background-color: #fff
}

.m-l-18 {
    margin-left: 18%
}

.panel-group .panel-heading a.collapsed span {
    color: #414141
}

.m-l-7 {
    margin-left: 7%
}

.m-l-4 {
    margin-left: 4%
}

.pad-bottom {
    bottom: 0;
    position: absolute;
    padding: 0
}

.img-bottom {
    bottom: 48px;
    position: absolute
}

li div.coverage-selected span.pad-bottom {
    color: #fff
}

.visible {
    visibility: visible !important
}

.notvisible {
    visibility: hidden !important
}

.bg-eee {
    background-color: #eee
}

.clearFix {
    clear: both
}

.p-20 {
    padding: 20px !important
}

.autoWidth {
    width: auto !important
}

.whiteSpace {
    white-space: normal
}

.additional_coverage .panel-default>.panel-heading {
    color: #fff !important;
    background-color: #7d3f98 !important;
    padding: 10px
}

@media screen and (max-width:420px) {
    .widthImg40 {
        margin-top: 0;
        width: 6%;
        margin-right: 0;
        margin-left: 2px
    }
}

@media screen and (max-width:976px) {
    .Pleats_CNB_medical .panel-default .panel-heading {
        color: #fff !important;
        background-color: #7d3f98 !important;
        padding: 10px
    }

    .widthImg40 {
        width: 6%;
        margin-right: 0;
        margin-left: 0
    }

    li#behavioralTile,
    li#dentalTile,
    li#medicalTile,
    li#moreProductsTile,
    li#pharmacyTile,
    li#visionTile {
        margin-bottom: 6px
    }

    .mob-bottom {
        bottom: -6px;
        left: 45% !important
    }
}

@media screen and (max-width:768px) {
    .widthImg40 {
        margin-top: 0;
        width: 10%;
        margin-right: 0;
        margin-left: 2px
    }

    .widthImg40 img {
        visibility: visible !important
    }

    .Pleats_CNB_medical .panel-default .panel-heading span {
        color: #fff !important;
        margin-top: 2px
    }

    .p-10,
    .Pleats_CNB_medical .coverage-panelBody {
        padding: 10px
    }

    .Pleats_CNB_medical .panel-title {
        margin-top: -4px
    }

    .Pleats_CNB_medical .width20 {
        padding: 0
    }

    .p-l-9 {
        padding-left: 17%
    }

    .pad-l-2-7 {
        padding-left: 3.7%
    }

    .RollupBoxes,
    .RollupDetail {
        width: 100% !important
    }

    .RollupBoxes {
        float: left
    }

    .noMarginTop {
        margin-top: 0 !important
    }

    .CNB_MODULE {
        background-color: #eee !important
    }

    .mobDisplay {
        width: 1200px;
        overflow-x: scroll
    }

    .inlinblk {
        display: inline-block !important
    }

    .width-300 {
        width: 300px
    }

    .width-1 {
        width: 325px
    }

    .width-2 {
        width: 650px
    }

    .width-3 {
        width: 975px
    }

    .width-4 {
        width: 1300px
    }

    .width-5 {
        width: 1625px
    }

    .right-scrollarrow1 {
        background-image: url(https://member.aetna.com/secure/member/images/claimsArrow.png) !important;
        right: 0 !important
    }

    .left-scrollarrow1,
    .right-scrollarrow1 {
        background-image: url(https://member.aetna.com/secure/member/images/claimsArrow_left.png);
        background-repeat: no-repeat;
        background-position: 50%;
        width: 14px;
        height: 40px;
        background-color: #fff;
        opacity: .9;
        display: inline-block;
        padding: 25px;
        position: absolute;
        top: -74px;
        visibility: visible
    }
}

.aet-txt-look {
    font-size: 24px !important;
    font-weight: 700 !important;
    text-align: center !important;
    font-family: Domaine Display !important;
    color: #2f3338;
    margin-bottom: 1% !important;
    margin-top: 1% !important
}`, "",{"version":3,"sources":["webpack://./src/assets/css/coverage.css"],"names":[],"mappings":"AAAA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;;IAEI;;;;;;QAMI;IACJ;AACJ;;AAEA;;IAEI;;;;;;QAMI;IACJ;AACJ;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB;AACJ;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb;AACJ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;IACxB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,4BAA4B;IAC5B;AACJ;;AAEA;;IAEI,mBAAmB;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,mDAAmD;IACnD;AACJ;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf;AACJ;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;IACnB;AACJ;;AAEA;;;;;IAKI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;IACnB;AACJ;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf;AACJ;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf;AACJ;;AAEA;;IAEI,yBAAyB;IACzB,eAAe;IACf;AACJ;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf;AACJ;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf;AACJ;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;;;;;;;;;;;;IAYI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,gCAAgC;IAChC;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;IAGI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,cAAc;IACd,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;;;;;;;;;;QAWI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX;AACJ;;AAEA;IACI;QACI,0BAA0B;QAC1B;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI,YAAY;QACZ,UAAU;QACV,WAAW;QACX,aAAa;QACb;IACJ;;IAEA;;QAEI,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,eAAe;QACf,eAAe;QACf,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI,qBAAqB;QACrB,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,UAAU;QACV,eAAe;QACf;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;QACI,YAAY;QACZ,cAAc;QACd,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI;IACJ;;IAEA;QACI,kBAAkB;IACtB;;IAEA;;QAEI,UAAU;QACV,WAAW;QACX,oBAAoB;QACpB,oBAAoB;IACxB;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,SAAS;QACT,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,cAAc;QACd;IACJ;;IAEA;QACI,0BAA0B;QAC1B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,WAAW;QACX;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,UAAU;QACV,UAAU;QACV;IACJ;;IAEA;;QAEI,UAAU;QACV,WAAW;QACX,oBAAoB;QACpB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,UAAU;QACV;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,aAAa;QACb,qBAAqB;QACrB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,YAAY;QACZ,kBAAkB;QAClB,gBAAgB;QAChB,gBAAgB;QAChB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;;QAGI;IACJ;AACJ;;AAEA;IACI;QACI,WAAW;QACX;IACJ;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,yBAAyB;IACzB,UAAU;IACV;AACJ;;AAEA;IACI,2FAA2F;IAC3F,qBAAqB;IACrB,WAAW;IACX;AACJ;;AAEA;IACI,6EAA6E;IAC7E,4BAA4B;IAC5B,eAAe;IACf;AACJ;;AAEA;IACI,8EAA8E;IAC9E,4BAA4B;IAC5B,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,WAAW;IACX,cAAc;IACd,eAAe;IACf,aAAa;IACb;AACJ;;AAEA;IACI,yFAAyF;IACzF;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;IACnB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;;IAMI,iCAAiC;IACjC;AACJ;;AAEA;;;;;;IAMI,8BAA8B;IAC9B;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,QAAQ;IACR,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;IACxB,oBAAoB;IACpB;AACJ;;AAEA;;IAEI,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;IAII,WAAW;IACX,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;IACxB,oBAAoB;IACpB;AACJ;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA,2DAA2D;AAC3D,qCAAqC;IACjC,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB;AACJ;AACA;;AAEA,qCAAqC;IACjC;AACJ,CAAC;;AAED;IACI,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,YAAY;QACZ;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;;IAEA;QACI,kBAAkB;QAClB;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,WAAW;IACX,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;IAC3B;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI,sBAAsB;IACtB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,2BAA2B;QAC3B,0BAA0B;QAC1B,6BAA6B;QAC7B,yBAAyB;QACzB;IACJ;;IAEA;QACI,2BAA2B;QAC3B,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B,0BAA0B;QAC1B,6BAA6B;QAC7B;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,2BAA2B;QAC3B,0BAA0B;QAC1B,6BAA6B;QAC7B,yBAAyB;QACzB;IACJ;;IAEA;QACI,2BAA2B;QAC3B,+BAA+B;QAC/B;IACJ;;IAEA;QACI,+BAA+B;QAC/B,0BAA0B;QAC1B,6BAA6B;QAC7B;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,2BAA2B;QAC3B,0BAA0B;QAC1B,6BAA6B;QAC7B,yBAAyB;QACzB;IACJ;;IAEA;QACI,2BAA2B;QAC3B,gCAAgC;QAChC,0BAA0B;QAC1B;IACJ;;IAEA;QACI,+BAA+B;QAC/B,0BAA0B;QAC1B,6BAA6B;QAC7B;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,2BAA2B;QAC3B;IACJ;;IAEA;QACI,4BAA4B;QAC5B;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,UAAU;QACV;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;IACxB,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,QAAQ;IACR;AACJ;;AAEA;IACI,6EAA6E;IAC7E,QAAQ;IACR;AACJ;;AAEA;;IAEI,6EAA6E;IAC7E,UAAU;IACV;AACJ;;AAEA;IACI;QACI,oBAAoB;QACpB;IACJ;;IAEA;QACI,wFAAwF;QACxF,mBAAmB;QACnB;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,oBAAoB;IACpB;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,6BAA6B;IAC7B,mBAAmB;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,wBAAwB;IACxB,UAAU;IACV,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,yBAAyB;IACzB,aAAa;IACb;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,8BAA8B;IAC9B,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oCAAoC;IACpC;AACJ;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,0BAA0B;IAC1B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,WAAW;QACX;IACJ;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,wCAAwC;IACxC,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,gCAAgC;IAChC,8BAA8B;IAC9B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;;IAEI,yBAAyB;IACzB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB;AACJ;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,oCAAoC;IACpC;AACJ;;AAEA;IACI;QACI,aAAa;QACb,SAAS;QACT,eAAe;QACf;IACJ;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,oCAAoC;QACpC;IACJ;;IAEA;QACI,SAAS;QACT,eAAe;QACf;IACJ;;IAEA;;;;;;QAMI;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;AACJ;;AAEA;IACI;QACI,aAAa;QACb,UAAU;QACV,eAAe;QACf;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;;QAEI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,aAAa;QACb;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,+FAA+F;QAC/F;IACJ;;IAEA;;QAEI,yFAAyF;QACzF,4BAA4B;QAC5B,wBAAwB;QACxB,WAAW;QACX,YAAY;QACZ,sBAAsB;QACtB,WAAW;QACX,qBAAqB;QACrB,aAAa;QACb,kBAAkB;QAClB,UAAU;QACV;IACJ;AACJ;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,6BAA6B;IAC7B,uCAAuC;IACvC,cAAc;IACd,4BAA4B;IAC5B;AACJ","sourcesContent":[".hide {\n    visibility: hidden !important\n}\n\na.bottom-mrgn img {\n    margin: 0 10px 0 0\n}\n\n.arr-icon-blue {\n    margin-left: 5px\n}\n\n.view-for-select .form-control.custom {\n    width: 72%;\n    margin-left: 21px\n}\n\n@media screen and (min-width:768px) {\n\n    div#additional_coverage .view-for-select .form-control.custom,\n    div#behavioral .view-for-select .form-control.custom,\n    div#dentals .view-for-select .form-control.custom,\n    div#medicals .view-for-select .form-control.custom,\n    div#pharmacy .view-for-select .form-control.custom,\n    div#vision .view-for-select .form-control.custom {\n        width: 33%\n    }\n}\n\n@media screen and (max-width:767px) {\n\n    div#additional_coverage .view-for-select .form-control.custom,\n    div#behavioral .view-for-select .form-control.custom,\n    div#dentals .view-for-select .form-control.custom,\n    div#medicals .view-for-select .form-control.custom,\n    div#pharmacy .view-for-select .form-control.custom,\n    div#vision .view-for-select .form-control.custom {\n        width: 53%\n    }\n}\n\n.PCPErrorMsg {\n    border-top: 3px solid;\n    border-top-color: red;\n    background: #eee\n}\n\n.notetxt {\n    border: none;\n    background: #fff;\n    padding: 10px;\n    margin: 10px 0\n}\n\n.restrictiontext {\n    color: #a94442;\n    margin-left: 8.2%;\n    padding-top: 3%\n}\n\n.p-t-3 {\n    padding-top: 3%\n}\n\n.noborder {\n    border: 0 !important\n}\n\n.coverage-panelBody .accordion-grid-content p {\n    margin: 15px 20px\n}\n\n.collapse-viewfor.open:before {\n    background: url(https://member.aetna.com/secure/member/images/collapse_all.png) no-repeat\n}\n\n.pcp-coverage-block {\n    border: 1px solid #ccc;\n    box-shadow: 0 0 3px #ccc;\n    padding: 15px;\n    margin-top: 20px\n}\n\n.pcp-namecontent {\n    margin: 15px 0\n}\n\n.pcp-namecontent h2 {\n    font-size: 24px\n}\n\n.pcp-dateContent .span-block {\n    display: block\n}\n\n.benifits_journey .coverage-div h2 {\n    font-size: 18px;\n    font-weight: 700;\n    margin-top: 10px\n}\n\n.benifits_journey .rightSec h4 {\n    font-weight: 700\n}\n\n.coverage-pleats-add {\n    margin-left: 2px\n}\n\n.behavioral {\n    margin: 20px 0\n}\n\nul.bulletType_disc_coverage {\n    padding-left: 15px\n}\n\nul.bulletType_disc_coverage,\nul.bulletType_disc_coverage li {\n    list-style: disc outside none\n}\n\n.rightSec a {\n    font-weight: 700\n}\n\n.memberSelectorPannel {\n    background-color: #fff\n}\n\n#headingTen .panelTitle-text,\ndiv.panelText .panelTitle-text {\n    color: #000 !important\n}\n\n#tab10 .col-xs-3.pad0,\n#tab10 .col-xs-6.pad0 {\n    border-right: 1px solid #ccc;\n    min-height: 46px\n}\n\n#tab10 img,\n.findBulletin img {\n    margin: 0 8px 0 4px;\n    vertical-align: text-top\n}\n\n.summerySection .benifit-medical-name {\n    font-size: 18px;\n    color: #000;\n    font-weight: 700\n}\n\n.topMrgn30 {\n    margin-top: 30px\n}\n\nh4.benifit-medical-name a {\n    font-size: 16px;\n    margin-left: 20px\n}\n\n.progress {\n    margin-bottom: 5px;\n    margin-top: 5px;\n    height: 24px;\n    border-radius: 10px;\n    box-shadow: inset 0 1px 2px 0 hsla(0, 0%, 71%, .49);\n    background: #fff\n}\n\n.findBulletin {\n    border-top: 2px solid #ccc;\n    margin-top: 15px;\n    padding-top: 10px !important\n}\n\n.infogram-decuctible {\n    padding: 0 0 10px\n}\n\n.progress-bar.gray {\n    background: #4b65ae\n}\n\n.progress-bar {\n    border-radius: 10px;\n    margin: 3px;\n    height: 18px\n}\n\n.coverage-result-div .progress {\n    height: 30px;\n    border-radius: 20px\n}\n\n.coverage-result-div .progress-bar {\n    margin: 6px;\n    height: 18px;\n    margin-top: 6px\n}\n\n.sm-network {\n    font-size: 12px;\n    margin-left: 20px;\n    color: #4e7d2a;\n    font-weight: 700\n}\n\n.infogram-decuctible p {\n    margin-bottom: 0\n}\n\n.top-mrgn {\n    margin-top: 30px\n}\n\n#tab16 p a img {\n    margin: 0 5px\n}\n\n.secondrow .annualDed {\n    margin-top: 66px\n}\n\n.rightSec {\n    margin: 35px 0 20px;\n    background-color: #eee;\n    padding: 10px 15px\n}\n\n.m-b-20,\n.rightSec p {\n    margin-bottom: 20px\n}\n\n.annualDed {\n    background-color: #fff;\n    padding: 10px;\n    margin-top: 35px;\n    font-size: 14px;\n    box-shadow: 0 2px 10px 0 #9e9e9e\n}\n\n.annualDed b {\n    font-size: 22px\n}\n\n.inline {\n    display: inline-block\n}\n\n.bg-white {\n    background-color: #fff;\n    border: 1px solid #ccc;\n    margin: 0 0 30px\n}\n\n.top.pull-right {\n    margin: 10px\n}\n\n.tblcell {\n    display: table-cell;\n    color: #076f86;\n    font-size: 14px;\n    text-align: center\n}\n\n.tblLinksCell {\n    display: table-cell;\n    color: #7d3f98;\n    font-size: 16px;\n    text-align: left;\n    padding-left: 10px\n}\n\n.col-xs-3.pad0 a,\n.col-xs-6.pad0 a {\n    display: table\n}\n\n.coverage-overview .aet-content-fluid {\n    margin: 0 auto;\n    padding-left: 15px\n}\n\n.coverage-overview ul li {\n    margin: 0 4px\n}\n\n.coverage-overview ul li a {\n    display: block;\n    width: 100%\n}\n\n.coverage-div {\n    color: #fff\n}\n\n.bottom-top1 {\n    border-top: 3px solid #69747a\n}\n\n.coverage-div p,\n.font-white {\n    color: #fff\n}\n\n.dental-coverage {\n    background-color: #7d3f98;\n    border: 3px solid #7d3f98 !important\n}\n\n.dental-coverage-new {\n    border-color: #7d3f98;\n    background-color: #fff;\n    border-width: 1px 1px 1px 8px;\n    border-style: solid;\n    color: #000\n}\n\n.dental-coverage p,\n.health-coverage p,\n.medical-coverage p,\n.pharmacy-coverage p,\n.vision-coverage p {\n    margin-left: 2px\n}\n\n.dental-coverage-border {\n    border-top-color: #7d3f98\n}\n\n.panel-group.dental .panel-heading {\n    background-color: #7d3f98\n}\n\n.coverage-p {\n    color: #fff !important\n}\n\n.medical-coverage {\n    background-color: #7d3f98;\n    border: 3px solid #7d3f98 !important\n}\n\n.medical-coverage-new {\n    border-color: #7d3f98;\n    background-color: #fff;\n    border-width: 1px 1px 1px 8px;\n    border-style: solid;\n    color: #000\n}\n\n.medical-coverage-border {\n    border-top-color: #7d3f98\n}\n\n.panel-group.medical .panel-heading {\n    background-color: #7d3f98\n}\n\n.coverage-p-new {\n    color: #000 !important\n}\n\n.health-coverage {\n    background-color: #7d3f98;\n    border: 3px solid #7d3f98 !important\n}\n\n.health-coverage-new {\n    border-color: #7d3f98;\n    background-color: #fff;\n    border-width: 1px 1px 1px 8px;\n    border-style: solid;\n    color: #000\n}\n\n.health-coverage-border {\n    border-top-color: #7d3f98\n}\n\n.panel-group.behavioral .panel-heading,\n.panel-group.health .panel-heading {\n    background-color: #7d3f98\n}\n\n.pharmacy-coverage {\n    background-color: #4b65ae;\n    border: 3px solid #4b65ae !important\n}\n\n.pharmacy-coverage-new {\n    border-color: #7d3f98;\n    background-color: #fff;\n    border-width: 1px 1px 1px 8px;\n    border-style: solid;\n    color: #000\n}\n\n.panel-group.pharmacy .panel-heading {\n    background-color: #7d3f98\n}\n\n.pharmacy-coverage-border {\n    border-top-color: #7d3f98\n}\n\n.additional-coverage {\n    background-color: #7d3f98;\n    border: 3px solid #7d3f98 !important\n}\n\n.additional-coverage-border {\n    border-top-color: #7d3f98\n}\n\n.additional-coverage-new {\n    border-color: #7d3f98;\n    background-color: #fff;\n    border-width: 1px 1px 1px 8px;\n    border-style: solid;\n    color: #000\n}\n\n.helpful_information .medical .helpfulapp {\n    color: #1d7564 !important;\n    font-size: 12px;\n    font-weight: 700\n}\n\n.helpful_information .dental .helpfulapp {\n    color: #4e7d2a !important;\n    font-size: 12px;\n    font-weight: 700\n}\n\n.helpful_information .behavioral .helpfulapp,\n.helpful_information .health .helpfulapp {\n    color: #4b65ae !important;\n    font-size: 12px;\n    font-weight: 700\n}\n\n.helpful_information .vision .helpfulapp {\n    color: #1b7fcf !important;\n    font-size: 12px;\n    font-weight: 700\n}\n\n.helpful_information .pharmacy .helpfulapp {\n    color: #4b65ae !important;\n    font-size: 12px;\n    font-weight: 700\n}\n\n.helpful_information .additional .helpfulapp {\n    color: #526f83 !important;\n    font-size: 12px;\n    font-weight: 700\n}\n\n.panel-group.additional .panel-heading {\n    background-color: #7d3f98\n}\n\n.coverage-overview {\n    background-color: #eee;\n    padding: 15px 0\n}\n\n.coverage-heading {\n    color: #406622;\n    font-size: 18px;\n    font-weight: 700;\n    padding-right: 25px;\n    display: inline-block\n}\n\n.coverage-idcard,\n.pleat-idcard {\n    font-weight: 700\n}\n\n.pleat-idcard {\n    float: center\n}\n\n#viewFor1 {\n    width: 32%;\n    margin-left: 25px\n}\n\n#viewFor,\n#viewFor1,\n#viewFor2,\n#viewFor3,\n#viewFor4,\n#viewFor5,\n#viewFor6,\n#viewFor7,\n#viewFor8,\n#viewFor9,\n#viewFor10,\n#viewFor11 {\n    display: inline-block\n}\n\n.coverage-result-div .aet-content-fluid {\n    padding-left: 15px\n}\n\n.view-for-select {\n    float: left;\n    width: 50%\n}\n\n.view-for {\n    margin-top: 25px;\n    overflow: auto;\n    margin-bottom: 25px\n}\n\n.form-group #viewFor {\n    width: 100%;\n    margin-left: 0\n}\n\n.expand-collapse-med {\n    margin: 5px 0 5px -38px\n}\n\n.view-for-collapse {\n    text-align: right\n}\n\n.view-addl-cov {\n    margin-left: -19px\n}\n\n.expand-collapse {\n    margin: 20px 0 0 -25px\n}\n\n.view-for-addl-cov span,\n.view-for-collapse span {\n    color: #1c8ba6;\n    font-weight: 700\n}\n\n.collapse-viewfor {\n    margin-left: 20px\n}\n\n.accordionFindings {\n    padding: 15px\n}\n\n.accordion-grid-header {\n    overflow: auto;\n    clear: both;\n    height: 100%;\n    background-color: #eee;\n    padding-right: 15px;\n    padding-left: 15px;\n    font-weight: 700;\n    padding: 0\n}\n\n.gridContent,\n.gridHeading {\n    padding: 15px 17px\n}\n\n.no-padding-right,\n.rightSplit div:last-child div:last-child {\n    padding-right: 0\n}\n\n.rightSplit div:first-child div:first-child a {\n    display: block\n}\n\n.maternity-care,\n.read-more-link {\n    display: inline-block !important;\n    font-weight: 700\n}\n\n.accordion-grid-content-row {\n    overflow: hidden\n}\n\n.leftSplit,\n.rightSplit {\n    border-top: 1px solid #ccc\n}\n\n.mergedRow .rightSplit {\n    border-left: 1px solid #ccc\n}\n\n.accordion-grid-content-row:first-child .leftSplit,\n.accordion-grid-content-row:first-child .rightSplit,\n.noBorderTop {\n    border-top: none !important\n}\n\n.accordion-grid-content-row:last-child,\n.bottom-border {\n    border-bottom: 1px solid #ccc\n}\n\n.accordion-grid-content {\n    clear: both;\n    overflow: hidden\n}\n\n.panel-group .panel+.panel {\n    margin-top: -1px\n}\n\n.estimate,\n.highlight {\n    color: #076f86;\n    font-weight: 700;\n    cursor: pointer\n}\n\n.coverage-panelBody {\n    padding: 0\n}\n\n.benifit-medical-name {\n    font-size: 20px;\n    color: #4e7d2a\n}\n\n@media screen and (max-width:767px) {\n    .navbar-toggle {\n        display: block !important\n    }\n\n    .benifit-medical-name,\n    .coverage-heading {\n        font-size: 16px\n    }\n\n    .coverage-div {\n        height: 60px !important\n    }\n\n    #tab2 .accordionFindings span {\n        width: 44% !important\n    }\n\n    #tab3 .accordionFindings span {\n        width: 17% !important\n    }\n\n    #tab9 .accordionFindings span {\n        width: 30% !important\n    }\n\n    #viewFor,\n    #viewFor2,\n    #viewFor3,\n    #viewFor4,\n    #viewFor5,\n    #viewFor6,\n    #viewFor7,\n    #viewFor8,\n    #viewFor9,\n    #viewFor10,\n    #viewFor11 {\n        padding-right: 51px\n    }\n\n    h4.col-sm-12.font-head.benifit-medical-name.pad0 {\n        width: 45%\n    }\n\n    .txt-right {\n        width: 40%\n    }\n\n    .bg-white {\n        margin: 60px 0 30px\n    }\n}\n\n.expand-collapse-med .collapse-viewfor {\n    display: inline-block\n}\n\n@media screen and (max-width:768px) {\n    .SBC #LinkSBC span.plus_minus {\n        width: 5%\n    }\n\n    .SBC #LinkSBC span.panelTitle-text {\n        width: 91%\n    }\n}\n\n.Pleats_CNB_medical .panel-group.indicator_right .plus_minus {\n    background-position: 100%;\n    float: none;\n    margin-right: 12px\n}\n\n@media screen and (max-width:991px) {\n    .col-sm-12.col-md-3.pad0.col-xs-12 {\n        border-top: 2px solid #ccc;\n        margin: 10px 0\n    }\n\n    .col-sm-12.col-md-3.pad0.col-xs-12 .col-xs-6.pad0,\n    .m-t-15 {\n        margin-top: 15px\n    }\n\n    .notetxt a img {\n        margin: 0 5px\n    }\n\n    .pharmacy-sce .accordion-grid-content-row:last-child {\n        border-bottom: none !important\n    }\n\n    #tab10 img {\n        vertical-align: top\n    }\n\n    #additional .view-for-addl-cov,\n    #additional .view-for-collapse {\n        float: right;\n        width: 35%;\n        clear: none;\n        margin-top: 0;\n        padding-top: 0\n    }\n\n    #additional .view-for-addl-cov span:first-child,\n    #additional .view-for-collapse span:first-child {\n        width: 80%;\n        text-align: right\n    }\n\n    #additional .heading-idcard {\n        margin: 25px 0 0 10px\n    }\n\n    #tab10 .col-xs-3.pad0,\n    #tab10 .col-xs-6.pad0 {\n        border-right: 0\n    }\n\n    .mobHeading.hidden-md.hidden-lg.bold {\n        color: #000\n    }\n\n    .col-xs-2.leftSplit {\n        font-weight: 700\n    }\n\n    .coverageSubtext {\n        font-weight: 400;\n        font-size: 15px\n    }\n\n    .gridContent {\n        padding: 5px 15px\n    }\n\n    .panel-title img {\n        width: 26px;\n        height: 27px\n    }\n\n    .mergedRow .rightSplit {\n        border-left: none\n    }\n\n    .coverage-div {\n        height: 90px;\n        margin-right: 1%;\n        margin-left: 1%;\n        padding-left: 0;\n        text-align: center;\n        padding-right: 0\n    }\n\n    .coverage-overview {\n        background-color: #fff\n    }\n\n    .benifits_journey .coverage-div h2 {\n        font-size: 14px;\n        text-align: center\n    }\n\n    .coverage-result-div .aet-content-fluid {\n        padding-left: 10px\n    }\n\n    .coverage-heading {\n        display: inline-block\n    }\n\n    .coverage-idcard {\n        width: 38%;\n        text-align: right\n    }\n\n    #viewFor {\n        width: 70%\n    }\n\n    .view-for-select {\n        width: 50%\n    }\n\n    .view-for-addl-cov span:first-child,\n    .view-for-collapse span:first-child {\n        display: inline-block;\n        float: left;\n        width: 93%\n    }\n\n    .collapse-viewfor {\n        display: inline-block\n    }\n\n    .accordionFindings span {\n        display: inline-block;\n        width: 50%;\n        font-size: 14px;\n        color: #000\n    }\n\n    .accordionFindings button {\n        float: right;\n        font-size: 13px\n    }\n\n    .heading {\n        font-weight: 700\n    }\n\n    .accordionFindings {\n        float: none !important;\n        overflow: hidden\n    }\n\n    .coverage-idcard {\n        float: right;\n        overflow: auto;\n        text-align: left;\n        font-size: 16px;\n    }\n\n    .panel.panel-default {\n        font-size: 14px;\n    }\n\n    .annualDed,\n    .secondrow .annualDed {\n        margin-top: 0\n    }\n\n    .summerySection.clearfix {\n        padding-right: 1px;\n    }\n\n    .infogram-coinsurance,\n    .infogram-decuctible {\n        width: 50%;\n        float: left;\n        padding-bottom: 15px;\n        margin: 0 !important;\n    }\n\n    .right-content {\n        width: 50%;\n        float: right;\n        top: 37px;\n        padding: 0 0 0 10px;\n    }\n\n    h4.col-sm-12.font-head.benifit-medical-name.pad0 {\n        font-size: 16px;\n        float: left;\n    }\n\n    .panel-group .panel-heading span,\n    .txt-right {\n        font-size: 15px;\n    }\n\n    .txt-right {\n        float: right;\n        margin: 10px 0;\n        line-height: 17px\n    }\n\n    .col-sm-3.pad0.col-xs-12 {\n        border-top: 2px solid #ccc;\n        margin: 10px 0\n    }\n\n    .col-sm-3.pad0.col-xs-12 .col-xs-6.pad0 {\n        margin: 10px 0 0\n    }\n\n    h2.col-sm-12.font-head.benifit-medical-name.pad0 {\n        width: 100%\n    }\n\n    #viewFor1 {\n        width: 75%;\n        margin-left: 0\n    }\n\n    .behav-health .coverage-heading {\n        width: 100%\n    }\n\n    .behav-health .annualDed,\n    .behav-health .secondrow .annualDed {\n        margin-top: 12px\n    }\n}\n\n@media screen and (max-width:400px) {\n    .benifits_journey .coverage-div h2 {\n        font-size: 12px\n    }\n\n    label.col-xs-2.pad0.control-label {\n        font-size: 14px\n    }\n\n    .SBC #LinkSBC span.plus_minus {\n        width: 5%\n    }\n\n    .SBC #LinkSBC span.panelTitle-text {\n        width: 89%\n    }\n\n    span.m-b-SBC {\n        margin-bottom: 30px\n    }\n\n    span.m-b-11 {\n        margin-bottom: 11%\n    }\n\n    span.m-b-22 {\n        margin-bottom: 22%\n    }\n\n    .pad-l-4 {\n        padding: 0 0 0 11.3% !important\n    }\n}\n\n@media screen and (max-width:767px) {\n    .view-for-select {\n        width: 100%;\n        margin-bottom: 10px\n    }\n}\n\n@media screen and (min-width:768px) {\n    .coverage-overview ul li {\n        margin: 0 12px\n    }\n\n    .right-content {\n        width: 30%;\n        top: -81px;\n        padding: 0 16px 0 0\n    }\n\n    .infogram-coinsurance,\n    .infogram-decuctible {\n        width: 70%;\n        float: left;\n        padding-bottom: 15px;\n        margin: 0 !important\n    }\n\n    .pharmacy-sce .accordion-grid-content-row:last-child {\n        border-bottom: none !important\n    }\n\n    .getCost {\n        border-left: 1px solid #ccc;\n        padding: 16px\n    }\n\n    .top.pull-right {\n        margin: 20px 0\n    }\n\n    .no-mob-border {\n        border: none !important\n    }\n}\n\n.rightborder {\n    border-right: 1px solid #7d3f98 !important\n}\n\n@media screen and (min-width:992px) {\n    .col-xs-12.pad0.findBulletin {\n        border-top: 1px solid #ccc\n    }\n\n    .summerySection .col-sm-3.col-md-2 {\n        width: 20.666667%\n    }\n\n    .coverage-overview ul li {\n        margin: 0 15px\n    }\n\n    .notetxt a img {\n        margin: 0 5px\n    }\n\n    .right-content {\n        width: 25%;\n        top: 23px\n    }\n\n    .notetxt br {\n        display: none\n    }\n\n    h4.col-sm-12.font-head.benifit-medical-name.pad0 {\n        width: 44%\n    }\n\n    a.txt-right.clearfix {\n        margin: 9px 0;\n        display: inline-block;\n        font-weight: 700\n    }\n\n    .behav-health .annualDed {\n        margin-top: 9px\n    }\n\n    .behav-health .secondrow .annualDed {\n        margin-top: 56px\n    }\n\n    .link-display {\n        float: right;\n        padding-right: 1px;\n        font-weight: 700;\n        padding-top: 1px;\n        margin-left: 2px\n    }\n\n    .top-mrgn10 {\n        margin-top: 10px\n    }\n\n    .getCost {\n        height: 75px\n    }\n\n    .benefitCards div.aet-content-hdrtxt h1.no-margin-left,\n    .no-margin-left,\n    ul li a span.font-16 {\n        margin-left: 0 !important\n    }\n}\n\n@media screen and (max-width:768px) {\n    .panel-group .panel-heading span {\n        color: #fff;\n        font-size: 17px\n    }\n}\n\n.arrowIndicator {\n    content: \"\";\n    position: absolute;\n    margin-left: -13px;\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-width: 0 13px 13px;\n    z-index: 1;\n    margin-top: 2px\n}\n\n.blue-arrow {\n    background: url(https://member.aetna.com/secure/member/images/blue_arrow.png) no-repeat 0 0;\n    display: inline-block;\n    width: 11px;\n    height: 9px\n}\n\n.panel-group .panel-heading a .sign_plus {\n    background-image: url(https://member.aetna.com/secure/member/images/plus.png);\n    background-repeat: no-repeat;\n    padding: 0 15px;\n    height: 30px\n}\n\n.panel-group .panel-heading a .plus_minus {\n    background-image: url(https://member.aetna.com/secure/member/images/minus.png);\n    background-repeat: no-repeat;\n    padding: 0 11px;\n    height: 30px\n}\n\n.collapse-viewfor:before {\n    background: url(https://member.aetna.com/secure/member/images/expand_all_icon.png) no-repeat\n}\n\n.collapse-viewfor:before,\n.expand-viewfor {\n    content: \"\";\n    color: #076f86;\n    font-size: 20px;\n    margin: 0 4px;\n    padding-left: 22px\n}\n\n.expand-viewfor {\n    background: url(https://member.aetna.com/secure/member/images/collapse_all.png) no-repeat;\n    float: right\n}\n\n.no-margin {\n    margin: 0 !important\n}\n\n.m-r-5 {\n    margin-right: 5px\n}\n\n.marL5 {\n    margin-left: 5px\n}\n\n.Expand-Collapse-label {\n    font-size: 16px;\n    font-weight: 400;\n    font-family: calibri\n}\n\n.m-l-5 {\n    margin-left: 5px\n}\n\ndiv.coverage-overview ul.navigation li p {\n    bottom: -5px;\n    position: absolute\n}\n\n.vision-coverage {\n    background-color: #1b7fcf;\n    border: 3px solid #1b7fcf !important\n}\n\n.vision-coverage-new {\n    border-color: #1b7fcf;\n    background-color: #fff;\n    border-width: 1px 1px 1px 8px;\n    border-style: solid;\n    color: #000\n}\n\n.panel-group.vision .panel-heading {\n    background-color: #7d3f98 !important\n}\n\n.vision-coverage-border {\n    border-top-color: #1b7fcf\n}\n\n.animate-linear {\n    transition: all 1s linear\n}\n\n.right-border {\n    border-right: 1px solid #ccc !important\n}\n\n.p-10 {\n    padding: 10px\n}\n\n.p-15 {\n    padding: 15px\n}\n\n.m-b-10 {\n    margin-bottom: 10px\n}\n\n.p-t-15 {\n    padding-top: 15px\n}\n\n.p-b-30 {\n    padding-bottom: 30px\n}\n\ndiv.no-padding,\nspan.no-padding {\n    padding: 0 !important\n}\n\n@-moz-document url-prefix() {\n    .auto-height {\n        height: auto !important\n    }\n}\n\n.height-auto {\n    height: auto !important\n}\n\n.noTop,\n.noTopIE {\n    top: auto\n}\n\n@media screen and (max-width:320px) {\n    .coverage-overview ul li a {\n        width: 60px\n    }\n\n    .coverage-overview ul li {\n        margin: 0 1.5%\n    }\n}\n\n.bold {\n    font-weight: 700 !important\n}\n\ndiv#additional_coverage .coverage-accordian .panel-group .panel .panel-heading a.collapsed,\ndiv#behavioral .coverage-accordian .panel-group .panel .panel-heading a.collapsed,\ndiv#dentals .coverage-accordian .panel-group .panel .panel-heading a.collapsed,\ndiv#medicals .coverage-accordian .panel-group .panel .panel-heading a.collapsed,\ndiv#pharmacy .coverage-accordian .panel-group .panel .panel-heading a.collapsed,\ndiv#vision .coverage-accordian .panel-group .panel .panel-heading a.collapsed {\n    background-color: #fff !important;\n    border: 1px\n}\n\ndiv#additional_coverage .coverage-accordian .panel-group .panel,\ndiv#behavioral .coverage-accordian .panel-group .panel,\ndiv#dentals .coverage-accordian .panel-group .panel,\ndiv#medicals .coverage-accordian .panel-group .panel,\ndiv#pharmacy .coverage-accordian .panel-group .panel,\ndiv#vision .coverage-accordian .panel-group .panel {\n    margin-bottom: 20px !important;\n    border: 1px solid #d9d9d9 !important\n}\n\n.coverage-div {\n    height: 120px;\n    border-style: solid;\n    border-width: 1px 1px 1px 8px;\n    position: relative;\n    overflow: hidden\n}\n\n.coverage-div:before {\n    content: \"\";\n    position: absolute;\n    left: -24%;\n    top: -50%;\n    width: 0;\n    height: 200%;\n    opacity: 0\n}\n\n.green .coverage-div:before {\n    background-color: #4e7d2a\n}\n\n.canbPink .coverage-div:before {\n    background-color: #d20962\n}\n\n.anchorBlue .coverage-div:before {\n    background-color: #1d7564\n}\n\n.purpuleShade .coverage-div:before {\n    background-color: #7d3f98\n}\n\n.blue .coverage-div:before {\n    background-color: #4b65ae\n}\n\n.darkerGray .coverage-div:before {\n    background-color: #526f83\n}\n\n.navyblue .coverage-div:before {\n    background-color: #1b7fcf\n}\n\n.coverage-div:hover:before,\nli a:focus .coverage-div:before {\n    width: 150%;\n    opacity: 1;\n    transition: .55s;\n    -moz-transition: .55s;\n    -webkit-transition: .55s;\n    -ms-transition: .55s;\n    -o-transition: .55s\n}\n\n.coverage-div h2,\n.coverage-div p {\n    color: #000;\n    position: absolute\n}\n\n.coverage-div p {\n    bottom: -5px\n}\n\n.coverage-div:hover h2,\n.coverage-div:hover p,\nli a:focus .coverage-div h2,\nli a:focus .coverage-div p {\n    color: #fff;\n    transition: .25s;\n    -moz-transition: .25s;\n    -webkit-transition: .25s;\n    -ms-transition: .25s;\n    -o-transition: .25s\n}\n\n.covered {\n    background-color: #fff;\n    color: #000;\n    text-align: center;\n    width: 50%;\n    position: absolute;\n    bottom: 0;\n    margin-bottom: 15px\n}\n\n.green .coverage-div {\n    border-color: #4e7d2a\n}\n\n.anchorBlue .coverage-div {\n    border-color: #1d7564\n}\n\n.purpuleShade .coverage-div {\n    border-color: #7d3f98\n}\n\n.blue .coverage-div {\n    border-color: #4b65ae\n}\n\n.darkerGray .coverage-div {\n    border-color: #526f83\n}\n\n.navyblue .coverage-div {\n    border-color: #1b7fcf\n}\n\n.active.green .coverage-div {\n    background-color: #4e7d2a\n}\n\n.active.anchorBlue .coverage-div {\n    background-color: #1d7564\n}\n\n.active.purpuleShade .coverage-div {\n    background-color: #7d3f98\n}\n\n.active.blue .coverage-div {\n    background-color: #4b65ae\n}\n\n.active.darkerGray .coverage-div {\n    background-color: #526f83\n}\n\n.active.canbPink .coverage-div {\n    background-color: #d20962\n}\n\n.active .coverage-div h2,\n.active .coverage-div p {\n    color: #fff\n}\n\n.active.navyblue .coverage-div {\n    background-color: #1b7fcf\n}\n\n.font-bold {\n    font-weight: 700 !important\n}\n\n.pharmacyTile {\n    background-color: #7d3f98 !important\n}\n\n.pharmacyTileText {\n    color: #fff !important;\n    font-size: 20px !important\n}\n\n.m-l-15 {\n    margin-left: 15px\n}\n\n.m-t-10 {\n    margin-top: 10px\n}\n\n.pad-l-2-7 {\n    padding-left: 2.7%\n}\n\n.width-20 {\n    width: 20% !important\n}\n\n.text-left {\n    text-align: left\n}\n\n.SBH:before {\n    margin: 0 4px 1px 0 !important\n}\n\n.p-t-6 {\n    padding-top: 6px\n}\n\n.p-l-1 {\n    padding-left: 1.5% !important\n}\n\n@media screen and (max-width:500px) {\n    .coverage-div {\n        border-width: 1px 1px 1px 4px\n    }\n\n    .mob-border {\n        border: 1px solid #ccc !important\n    }\n\n    .rightborder1 {\n        border: none !important;\n    }\n}\n\n/* @media screen and (max-width:991px) .coverage-idcard { */\n@media screen and (max-width:991px) {.coverage-idcard {\n    float: left;\n    overflow: auto;\n    text-align: left;\n    font-size: 16px\n}\n}\n\n@media screen and (max-width:991px) {.scrollToContant {\n    float: left\n}}\n\n.icon-block-purple {\n    background: #7d3f98;\n    padding: 5px 6px;\n    border-radius: 20px\n}\n\n.Padding-Icon {\n    padding: 10px 0 13px\n}\n\n.no-margin-bottom {\n    margin-bottom: 0\n}\n\n.activity-page-header {\n    font-size: 18px\n}\n\n@media screen and (min-width:1200px) {\n    .dollar-val-align {\n        float: right;\n        padding-right: 72px\n    }\n\n    .dollar-val-align-applied {\n        float: right;\n        padding-right: 152px\n    }\n\n    .sub-charge-det {\n        float: right;\n        padding-right: 59px\n    }\n\n    .wellMatch-align {\n        padding-left: 37px;\n        padding-right: 191px\n    }\n}\n\n@media screen and (min-width:710px) and (max-width:1199px) {\n    .dollar-val-align {\n        padding-left: 47px\n    }\n\n    .dollar-val-align-applied {\n        padding-left: 10px\n    }\n}\n\n.rightborder1 {\n    border-right: 1px solid #ccc\n}\n\n@media screen and (max-width:709px) {\n    .dollar-val-align {\n        padding-left: 15px\n    }\n\n    .dollar-val-align-applied {\n        padding-left: 10px\n    }\n\n    .dollar-val-div-align,\n    .p-t-10 {\n        padding-top: 10px !important\n    }\n}\n\n.mobile-act-details {\n    display: block;\n    background-color: #fff;\n    color: #000;\n    border-bottom: 1px solid #ccc;\n    border-right: 1px solid #ccc;\n    border-left: 1px solid #ccc;\n    padding-right: 53px\n}\n\n@media screen and (min-width:451px) {\n    .mobile-activity-det-view {\n        display: none\n    }\n\n    .pad-l-4 {\n        padding-left: 3.3%\n    }\n}\n\n@media screen and (max-width:450px) {\n    .desktop-activity-det-view {\n        display: none\n    }\n}\n\n.headClass-Select {\n    color: #000 !important;\n    font-size: 16px\n}\n\n.headClass {\n    color: #fff !important;\n    font-size: 16px\n}\n\n@media screen and (max-width:991px) {\n    .mobile-activity-details {\n        display: none\n    }\n}\n\n@media screen and (max-width:991px) {\n    .mobile-activity-table {\n        text-align: left\n    }\n}\n\n@media screen and (max-width:991px) {\n    .mobile-plan-details-text {\n        margin-left: -10px\n    }\n}\n\n.link-style {\n    cursor: pointer;\n    color: #23527c\n}\n\n.mobile-activity-details-link {\n    margin-left: 4px\n}\n\n.activity-detail-page {\n    background-color: #eee\n}\n\n@media screen and (min-width:991px) {\n    .mobile-activity-PD-view {\n        display: none\n    }\n}\n\n@media screen and (max-width:990px) {\n    .desktop-activity-PD-view {\n        display: none\n    }\n}\n\n.note_image {\n    background: #7d3f98;\n    padding: 5px 6px;\n    border-radius: 20px\n}\n\n@media only screen and (min-device-width:361px) and (max-device-width:667px) and (-webkit-min-device-pixel-ratio:2) {\n    .padding-SM {\n        padding: 0 43px 0 5px\n    }\n\n    .img_iphone6 {\n        margin: 0 0 0 10px !important\n    }\n\n    .go_paperless_iph6 {\n        font-weight: 800 !important;\n        font-size: 14px !important;\n        padding-right: 6px !important;\n        color: #556b2f !important;\n        margin-left: 2px !important\n    }\n\n    .turn_paper_off {\n        font-weight: 400 !important;\n        margin: 0 4px 0 -8px !important;\n        font-size: 14px !important\n    }\n\n    .view_your_statements {\n        padding-bottom: 11px !important;\n        font-size: 14px !important;\n        margin: 0 0 0 11px !important;\n        width: 97% !important\n    }\n}\n\n@media only screen and (min-device-width:320px) and (max-device-width:359px) and (-webkit-min-device-pixel-ratio:2) {\n    .padding-SM {\n        padding: 0\n    }\n\n    .img_iphone5 {\n        margin: 0 0 0 10px !important\n    }\n\n    .go_paperless_iph5 {\n        font-weight: 700 !important;\n        font-size: 13px !important;\n        padding-right: 6px !important;\n        color: #556b2f !important;\n        margin-left: -2px !important\n    }\n\n    .turn_paper_off5 {\n        font-weight: 400 !important;\n        margin: 0 4px 0 -6px !important;\n        font-size: 13px !important\n    }\n\n    .view_your_statements5 {\n        padding-bottom: 11px !important;\n        font-size: 13px !important;\n        margin: 0 0 0 12px !important;\n        width: 97% !important\n    }\n}\n\n@media only screen and (min-device-width:412px) and (max-device-width:767px) and (-webkit-min-device-pixel-ratio:2) {\n    .padding-SM {\n        padding: 0 30px 0 5px\n    }\n\n    .img_iphone6pl {\n        margin: 0 0 0 10px !important\n    }\n\n    .go_paperless_iph6pl {\n        font-weight: 700 !important;\n        font-size: 16px !important;\n        padding-right: 6px !important;\n        color: #556b2f !important;\n        margin-left: 3px !important\n    }\n\n    .turn_paper_off_iph6pl {\n        font-weight: 400 !important;\n        margin: 0 4px 0 -12px !important;\n        font-size: 16px !important;\n        padding-left: 6px\n    }\n\n    .view_your_statements_iph6pl {\n        padding-bottom: 11px !important;\n        font-size: 16px !important;\n        margin: 0 0 0 11px !important;\n        width: 97% !important\n    }\n}\n\n@media only screen and (min-device-width:768px) and (max-device-width:1024px) and (-webkit-min-device-pixel-ratio:1) {\n    .img_ipad {\n        margin: 0 0 0 10px !important\n    }\n\n    .go_paperless_ipad {\n        font-weight: 800 !important;\n        color: #556b2f !important\n    }\n\n    .turn_paper_off_ipad {\n        font-weight: 500 !important;\n        margin: 0 0 0 3px !important\n    }\n\n    .view_your_statements_ipad {\n        margin: 0 0 0 3px !important;\n        font-size: 16px\n    }\n}\n\n.progress-Bar-Width {\n    width: 330px\n}\n\n.margin-Vision {\n    margin-left: 10px\n}\n\n.margin-vision-header {\n    margin: 10px 0 10px 10px\n}\n\n.turn-paper-off-desktopImageMargin {\n    margin: 0 0 0 13px !important\n}\n\n.GoPaperlessDesktop {\n    font-weight: 800;\n    color: #556b2f\n}\n\n.turnPaperOffurlDesktop {\n    font-weight: 500;\n    margin-left: 7px\n}\n\n.visit24-7-Desktop {\n    margin: 0 0 0 3px\n}\n\n.visitHealthCare {\n    font-weight: 500;\n    margin: 10px 0 10px 13px\n}\n\n.imgExternalLink {\n    margin: 3px 0 0 !important\n}\n\n@media screen and (max-width:769px) {\n    .fin-head {\n        padding-top: 0\n    }\n}\n\n@media screen and (min-width:770px) {\n    .fin-head {\n        padding-top: 10px\n    }\n}\n\n.covBen_pleats_title {\n    font-size: 16px;\n    font-weight: 700\n}\n\n.summary-benefits-before {\n    padding-top: 9px\n}\n\n.p-t-17,\n.summary-benefits-after-help {\n    padding-top: 17px !important\n}\n\n.no-decoration {\n    text-decoration: none !important\n}\n\n.margin-2 {\n    margin: 2px !important\n}\n\n.view-medical-plans {\n    margin-right: 1px !important\n}\n\n.pad-change-doc {\n    padding-top: 4px\n}\n\n.breakWord {\n    word-wrap: break-word\n}\n\n@media screen and (min-width:400px) and (max-width:500px) {\n    .coverage-overview ul li.col-xs-2 {\n        width: 18%;\n        margin: 0 3px\n    }\n}\n\n.bot-margin {\n    padding-bottom: 12px\n}\n\n.rbp-top-block {\n    border: 1px solid #ccc;\n    box-shadow: 0 0 3px #ccc;\n    padding: 15px;\n    margin-top: 20px;\n    margin-left: 15px;\n    margin-right: 45px;\n    position: relative\n}\n\n.rbp-facilities-block {\n    margin-top: 20px;\n    margin-right: 60px;\n    position: relative\n}\n\n#memberDropDown {\n    display: inline-block;\n    width: 82%\n}\n\n.facilityTableCode {\n    font-size: 8px\n}\n\n.pt-10 {\n    padding: 10px 0\n}\n\n.panel-group .panel-heading a.collapsed .plus_minus:after {\n    top: 7px;\n    right: 1px\n}\n\n.panel-group .panel-heading a.collapsed .plus_minus {\n    background-image: url(https://member.aetna.com/secure/member/images/plus.png);\n    right: 0;\n    top: 5px\n}\n\n.panel-group .panel-heading a#LinkSBC .plus_minus,\n.panel-group .panel-heading a.Additional_Products .plus_minus {\n    background-image: url(https://member.aetna.com/secure/member/images/plus.png);\n    right: 5px;\n    top: 5px\n}\n\n@-moz-document url-prefix() {\n    .panel-group .panel-heading a.collapsed .plus_minus:after {\n        top: 12px !important;\n        right: 1px !important\n    }\n\n    .panel-group .panel-heading a.collapsed .plus_minus {\n        background-image: url(https://member.aetna.com/secure/member/images/plus.png) !important;\n        right: 0 !important;\n        top: 0 !important\n    }\n\n    .panel-group .panel-heading a.collapsed .plus_minus:before {\n        top: 4px !important\n    }\n}\n\nsup {\n    top: .1em !important;\n    font-size: 24px !important\n}\n\n.no-margin-top {\n    margin-top: 0 !important\n}\n\n.f-right,\n.text-right {\n    float: right !important\n}\n\n.p-l-28 {\n    padding-left: 28px !important\n}\n\n.displayTextInline {\n    display: inline\n}\n\n.coverage-selected {\n    background-color: #7d3f98;\n    border: 3px solid #7d3f98 !important\n}\n\n.coverage-default {\n    border-color: #b18cc1;\n    background-color: #b18cc1;\n    border-width: 1px 1px 1px 8px;\n    border-style: solid;\n    color: #000\n}\n\n.coverage-tile {\n    height: 120px;\n    border-style: solid;\n    border-width: 1px;\n    position: relative;\n    overflow: hidden\n}\n\n.coverage-selected,\n.coverage-selected p {\n    color: #fff\n}\n\n.downArrowIndicator {\n    content: \"\";\n    position: absolute;\n    margin-left: -13px;\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-width: 0 11px 6px;\n    z-index: 1;\n    transform: rotate(180deg);\n    border-color: transparent transparent #7d3f98\n}\n\n.tileBottom {\n    border: 1px solid #7d3f98\n}\n\n.m-t-3 {\n    margin-top: 3px\n}\n\n.benefitNote {\n    background: #fff\n}\n\n.activityNote,\n.benefitNote {\n    border: 1px solid #d9d9d9;\n    padding: 10px;\n    margin: 10px 0\n}\n\n.CNB_MODULE .coverage-tile h2,\n.m-t-8 {\n    margin-top: 8px !important\n}\n\n.benefitCards select,\n.CNB_MODULE select {\n    border-color: #d9d9d9 !important\n}\n\n.Pleats_CNB_medical .tile_seperator span {\n    font-size: 16px;\n    color: #7d3f98 !important;\n    font-weight: 400\n}\n\n.Pleats_CNB_medical .nav-tabs>li a {\n    border: none;\n    padding: 15px 9px 0 7px\n}\n\n.Pleats_CNB_medical .nav-tabs li {\n    margin-bottom: 1%\n}\n\n.Pleats_CNB_medical .nav-tabs>li a img {\n    border-radius: 0\n}\n\n.p-t-7 {\n    padding-top: 7px\n}\n\n.Pleats_CNB_medical ul.nav-tabs {\n    border-bottom: none !important;\n    padding: 0;\n    background-color: #eee\n}\n\n.benefitNote span {\n    color: #7d3f98 !important\n}\n\n.Pleats_CNB_medical .nav-tabs .home_group {\n    border: 2px solid #d9d9d9 !important;\n    box-shadow: 0 0 0 #d9d9d9\n}\n\n.CNB_MODULE .memberDropDownBox {\n    border: 1px solid #d9d9d9;\n    background: #fff;\n    padding: 10px;\n    margin: 0 0 30px\n}\n\n.CNB_MODULE ul li {\n    margin: 0 15px 0 0\n}\n\n@media (min-width:768px) {\n    #main-div .coverageContainer {\n        width: auto !important\n    }\n}\n\n@media (min-width:1200px) {\n    #main-div .coverageContainer {\n        width: 1308px !important\n    }\n}\n\n.coverage-result-div .container .aet-content-fluid {\n    max-width: 100% !important;\n    padding-left: 0 !important\n}\n\n.p-t-13 {\n    padding-top: 13px\n}\n\n.p-t-1 {\n    padding-top: 1px\n}\n\n.font-normal {\n    font-weight: 400\n}\n\n@media screen and (min-width:1281px) {\n    .Pleats_CNB_medical ul li .HILBMenu {\n        width: 110%;\n        padding-left: 12px !important\n    }\n}\n\n.planBalanceHeading,\n.progress-bar.pink {\n    background: #7d3f98 !important\n}\n\n.dedAmount {\n    padding-left: 0;\n    margin-bottom: 15px\n}\n\n.p-t-5 {\n    padding-top: 5px !important\n}\n\n.p-l-6 {\n    padding-left: 6px\n}\n\n.finNote {\n    border: 1px solid #ccc;\n    background: #f8f8f8;\n    padding: 10px;\n    margin: 15px 0\n}\n\n.panel-group.anchorBlue .panel-heading a {\n    background: #7d3f98\n}\n\n.additional-coverage {\n    background-color: #b18cc1;\n    border: 3px solid #b18cc1 !important\n}\n\n.leftFloat {\n    float: left\n}\n\n.p-r-6 {\n    padding-right: 6px\n}\n\n.pleatsBox {\n    border-top: 2px solid #7d3f98 !important;\n    background: #fff;\n    padding: 0;\n    margin: 15px 6px;\n    border-bottom: 2px solid #d9d9d9;\n    border-left: 2px solid #d9d9d9;\n    border-right: 2px solid #d9d9d9\n}\n\n.p-l-9 {\n    padding-left: 9%\n}\n\n.p-12 {\n    padding: 12px !important\n}\n\n.no-padding-left {\n    padding-left: 0 !important\n}\n\n.cursorPointer {\n    cursor: pointer\n}\n\n.RollupDetail {\n    width: 98% !important\n}\n\n.RollupBoxes {\n    width: 50% !important;\n    float: left\n}\n\n.activityDetails .activityNote span,\n.medicalPlanContainer .benefitNote span {\n    color: #414141 !important;\n    font-size: 14px !important\n}\n\n.activityDetails span.linkColor {\n    color: #7d3f98 !important\n}\n\n.no-border {\n    border: none !important\n}\n\n.tblBorder {\n    border: 1px solid #d9d9d9 !important\n}\n\n.Pleats_CNB_medical li.home_group:hover {\n    background-color: #eee !important\n}\n\n.Pleats_CNB_medical li.home_group p.HILBMenu {\n    margin-left: -4% !important\n}\n\n.p-5 {\n    padding: 5px\n}\n\n.evenRows {\n    background-color: #f4f4f4\n}\n\n.p-l-4 {\n    padding-left: 4%\n}\n\n.p-l-3 {\n    padding-left: 3%\n}\n\n.full-width {\n    width: 100% !important\n}\n\n.m-l-14 {\n    margin-left: 14%\n}\n\n.oddRows {\n    background-color: #fff\n}\n\n.m-l-18 {\n    margin-left: 18%\n}\n\n.panel-group .panel-heading a.collapsed span {\n    color: #414141\n}\n\n.m-l-7 {\n    margin-left: 7%\n}\n\n.m-l-4 {\n    margin-left: 4%\n}\n\n.pad-bottom {\n    bottom: 0;\n    position: absolute;\n    padding: 0\n}\n\n.img-bottom {\n    bottom: 48px;\n    position: absolute\n}\n\nli div.coverage-selected span.pad-bottom {\n    color: #fff\n}\n\n.visible {\n    visibility: visible !important\n}\n\n.notvisible {\n    visibility: hidden !important\n}\n\n.bg-eee {\n    background-color: #eee\n}\n\n.clearFix {\n    clear: both\n}\n\n.p-20 {\n    padding: 20px !important\n}\n\n.autoWidth {\n    width: auto !important\n}\n\n.whiteSpace {\n    white-space: normal\n}\n\n.additional_coverage .panel-default>.panel-heading {\n    color: #fff !important;\n    background-color: #7d3f98 !important;\n    padding: 10px\n}\n\n@media screen and (max-width:420px) {\n    .widthImg40 {\n        margin-top: 0;\n        width: 6%;\n        margin-right: 0;\n        margin-left: 2px\n    }\n}\n\n@media screen and (max-width:976px) {\n    .Pleats_CNB_medical .panel-default .panel-heading {\n        color: #fff !important;\n        background-color: #7d3f98 !important;\n        padding: 10px\n    }\n\n    .widthImg40 {\n        width: 6%;\n        margin-right: 0;\n        margin-left: 0\n    }\n\n    li#behavioralTile,\n    li#dentalTile,\n    li#medicalTile,\n    li#moreProductsTile,\n    li#pharmacyTile,\n    li#visionTile {\n        margin-bottom: 6px\n    }\n\n    .mob-bottom {\n        bottom: -6px;\n        left: 45% !important\n    }\n}\n\n@media screen and (max-width:768px) {\n    .widthImg40 {\n        margin-top: 0;\n        width: 10%;\n        margin-right: 0;\n        margin-left: 2px\n    }\n\n    .widthImg40 img {\n        visibility: visible !important\n    }\n\n    .Pleats_CNB_medical .panel-default .panel-heading span {\n        color: #fff !important;\n        margin-top: 2px\n    }\n\n    .p-10,\n    .Pleats_CNB_medical .coverage-panelBody {\n        padding: 10px\n    }\n\n    .Pleats_CNB_medical .panel-title {\n        margin-top: -4px\n    }\n\n    .Pleats_CNB_medical .width20 {\n        padding: 0\n    }\n\n    .p-l-9 {\n        padding-left: 17%\n    }\n\n    .pad-l-2-7 {\n        padding-left: 3.7%\n    }\n\n    .RollupBoxes,\n    .RollupDetail {\n        width: 100% !important\n    }\n\n    .RollupBoxes {\n        float: left\n    }\n\n    .noMarginTop {\n        margin-top: 0 !important\n    }\n\n    .CNB_MODULE {\n        background-color: #eee !important\n    }\n\n    .mobDisplay {\n        width: 1200px;\n        overflow-x: scroll\n    }\n\n    .inlinblk {\n        display: inline-block !important\n    }\n\n    .width-300 {\n        width: 300px\n    }\n\n    .width-1 {\n        width: 325px\n    }\n\n    .width-2 {\n        width: 650px\n    }\n\n    .width-3 {\n        width: 975px\n    }\n\n    .width-4 {\n        width: 1300px\n    }\n\n    .width-5 {\n        width: 1625px\n    }\n\n    .right-scrollarrow1 {\n        background-image: url(https://member.aetna.com/secure/member/images/claimsArrow.png) !important;\n        right: 0 !important\n    }\n\n    .left-scrollarrow1,\n    .right-scrollarrow1 {\n        background-image: url(https://member.aetna.com/secure/member/images/claimsArrow_left.png);\n        background-repeat: no-repeat;\n        background-position: 50%;\n        width: 14px;\n        height: 40px;\n        background-color: #fff;\n        opacity: .9;\n        display: inline-block;\n        padding: 25px;\n        position: absolute;\n        top: -74px;\n        visibility: visible\n    }\n}\n\n.aet-txt-look {\n    font-size: 24px !important;\n    font-weight: 700 !important;\n    text-align: center !important;\n    font-family: Domaine Display !important;\n    color: #2f3338;\n    margin-bottom: 1% !important;\n    margin-top: 1% !important\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
